webpackJsonp([2],{

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(664)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(748),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(428),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'selection-btn',
  props: ['value']
});

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".title-btn{float:left;font-size:16px;margin-right:10px;color:#64696c}.selection-btn{float:left;cursor:pointer;width:65px;height:25px;position:relative;border-radius:4px;padding-top:2px;background-color:#a3a3a3;-webkit-transition:background-color .5s;transition:background-color .5s}.selection-btn:before{content:\"N\\C3O\";color:#fff;padding-left:28px;display:block;position:absolute;height:100%;-webkit-transition:transform .5s;-webkit-transition:-webkit-transform .5s;transition:-webkit-transform .5s;transition:transform .5s;transition:transform .5s,-webkit-transform .5s}.selection-btn.isActive{background:#5ebc61}.selection-btn.isActive:before{content:\"SIM\";padding-left:8px}.selection-btn:after{content:\" \";background-color:#fff;padding-left:10px;display:block;height:20px;width:20px;border-radius:4px;-webkit-transform:translate(5px);transform:translate(5px);-webkit-box-shadow:0 0 2px #848484;box-shadow:0 0 2px #848484;-webkit-transition:transform .3s;-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.selection-btn.isActive:after{-webkit-transform:translate(40px);transform:translate(40px)}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/SelectionBtn.vue"],"names":[],"mappings":"AACA,WACE,WAAY,AACZ,eAAgB,AAChB,kBAAmB,AACnB,aAAe,CAChB,AACD,eACE,WAAY,AACZ,eAAgB,AAChB,WAAY,AACZ,YAAa,AACb,kBAAkB,AAClB,kBAAmB,AACnB,gBAAgB,AAChB,yBAAyB,AACzB,wCAAyC,AACzC,+BAAiC,CAClC,AACD,sBACE,gBAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,cAAe,AACf,kBAAkB,AAClB,YAAa,AACb,iCAAkC,AAClC,yCAA0C,AAC1C,iCAAkC,AAClC,yBAA0B,AAC1B,8CAAiD,CAClD,AACD,wBACE,kBAAmB,CACpB,AACD,+BACI,cAAe,AACf,gBAAkB,CACrB,AACD,qBACE,YAAa,AACb,sBAAuB,AACvB,kBAAmB,AACnB,cAAe,AACf,YAAa,AACb,WAAY,AACZ,kBAAkB,AAClB,iCAAkC,AAC1B,yBAA0B,AAClC,mCAAoC,AAC5B,2BAA4B,AACpC,iCAAkC,AAClC,yCAA0C,AAC1C,iCAAkC,AAClC,yBAA0B,AAC1B,8CAAiD,CAClD,AACD,8BACE,kCAAmC,AAC3B,yBAA2B,CACpC","file":"SelectionBtn.vue","sourcesContent":["\n.title-btn{\n  float: left;\n  font-size: 16px;\n  margin-right: 10px;\n  color: #64696c;\n}\n.selection-btn{\n  float: left;\n  cursor: pointer;\n  width: 65px;\n  height: 25px;\n  position:relative;\n  border-radius: 4px;\n  padding-top:2px;\n  background-color:#a3a3a3;\n  -webkit-transition: background-color .5s;\n  transition: background-color .5s;\n}\n.selection-btn::before{\n  content: 'NÃO';\n  color: #fff;\n  padding-left: 28px;\n  display: block;\n  position:absolute;\n  height: 100%;\n  -webkit-transition: transform .5s;\n  -webkit-transition: -webkit-transform .5s;\n  transition: -webkit-transform .5s;\n  transition: transform .5s;\n  transition: transform .5s, -webkit-transform .5s;\n}\n.selection-btn.isActive{\n  background:#5ebc61;\n}\n.selection-btn.isActive::before{\n    content: 'SIM';\n    padding-left: 8px;\n}\n.selection-btn::after{\n  content: ' ';\n  background-color: #fff;\n  padding-left: 10px;\n  display: block;\n  height: 20px;\n  width: 20px;\n  border-radius:4px;\n  -webkit-transform: translate(5px);\n          transform: translate(5px);\n  -webkit-box-shadow: 0 0 2px #848484;\n          box-shadow: 0 0 2px #848484;\n  -webkit-transition: transform .3s;\n  -webkit-transition: -webkit-transform .3s;\n  transition: -webkit-transform .3s;\n  transition: transform .3s;\n  transition: transform .3s, -webkit-transform .3s;\n}\n.selection-btn.isActive::after{\n  -webkit-transform: translate(40px);\n          transform: translate(40px);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(416);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("17717350", content, true, {});

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selection-container"
  }, [_c('div', {
    staticClass: "title-btn"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    class: _vm.value ? 'selection-btn isActive' : 'selection-btn',
    on: {
      "click": function($event) {
        return _vm.$emit('input', !_vm.value)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Cropper.js v1.5.4
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2019-08-03T08:38:42.128Z
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Cropper = factory());
}(this, function () { 'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  var WINDOW = IS_BROWSER ? window : {};
  var IS_TOUCH_DEVICE = IS_BROWSER ? 'ontouchstart' in WINDOW.document.documentElement : false;
  var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
  var NAMESPACE = 'cropper'; // Actions

  var ACTION_ALL = 'all';
  var ACTION_CROP = 'crop';
  var ACTION_MOVE = 'move';
  var ACTION_ZOOM = 'zoom';
  var ACTION_EAST = 'e';
  var ACTION_WEST = 'w';
  var ACTION_SOUTH = 's';
  var ACTION_NORTH = 'n';
  var ACTION_NORTH_EAST = 'ne';
  var ACTION_NORTH_WEST = 'nw';
  var ACTION_SOUTH_EAST = 'se';
  var ACTION_SOUTH_WEST = 'sw'; // Classes

  var CLASS_CROP = "".concat(NAMESPACE, "-crop");
  var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
  var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
  var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
  var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
  var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
  var CLASS_MOVE = "".concat(NAMESPACE, "-move"); // Data keys

  var DATA_ACTION = "".concat(NAMESPACE, "Action");
  var DATA_PREVIEW = "".concat(NAMESPACE, "Preview"); // Drag modes

  var DRAG_MODE_CROP = 'crop';
  var DRAG_MODE_MOVE = 'move';
  var DRAG_MODE_NONE = 'none'; // Events

  var EVENT_CROP = 'crop';
  var EVENT_CROP_END = 'cropend';
  var EVENT_CROP_MOVE = 'cropmove';
  var EVENT_CROP_START = 'cropstart';
  var EVENT_DBLCLICK = 'dblclick';
  var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
  var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
  var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
  var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
  var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
  var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
  var EVENT_READY = 'ready';
  var EVENT_RESIZE = 'resize';
  var EVENT_WHEEL = 'wheel';
  var EVENT_ZOOM = 'zoom'; // Mime types

  var MIME_TYPE_JPEG = 'image/jpeg'; // RegExps

  var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
  var REGEXP_DATA_URL = /^data:/;
  var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
  var REGEXP_TAG_NAME = /^img|canvas$/i; // Misc
  // Inspired by the default width and height of a canvas element.

  var MIN_CONTAINER_WIDTH = 200;
  var MIN_CONTAINER_HEIGHT = 100;

  var DEFAULTS = {
    // Define the view mode of the cropper
    viewMode: 0,
    // 0, 1, 2, 3
    // Define the dragging mode of the cropper
    dragMode: DRAG_MODE_CROP,
    // 'crop', 'move' or 'none'
    // Define the initial aspect ratio of the crop box
    initialAspectRatio: NaN,
    // Define the aspect ratio of the crop box
    aspectRatio: NaN,
    // An object with the previous cropping result data
    data: null,
    // A selector for adding extra containers to preview
    preview: '',
    // Re-render the cropper when resize the window
    responsive: true,
    // Restore the cropped area after resize the window
    restore: true,
    // Check if the current image is a cross-origin image
    checkCrossOrigin: true,
    // Check the current image's Exif Orientation information
    checkOrientation: true,
    // Show the black modal
    modal: true,
    // Show the dashed lines for guiding
    guides: true,
    // Show the center indicator for guiding
    center: true,
    // Show the white modal to highlight the crop box
    highlight: true,
    // Show the grid background
    background: true,
    // Enable to crop the image automatically when initialize
    autoCrop: true,
    // Define the percentage of automatic cropping area when initializes
    autoCropArea: 0.8,
    // Enable to move the image
    movable: true,
    // Enable to rotate the image
    rotatable: true,
    // Enable to scale the image
    scalable: true,
    // Enable to zoom the image
    zoomable: true,
    // Enable to zoom the image by dragging touch
    zoomOnTouch: true,
    // Enable to zoom the image by wheeling mouse
    zoomOnWheel: true,
    // Define zoom ratio when zoom the image by wheeling mouse
    wheelZoomRatio: 0.1,
    // Enable to move the crop box
    cropBoxMovable: true,
    // Enable to resize the crop box
    cropBoxResizable: true,
    // Toggle drag mode between "crop" and "move" when click twice on the cropper
    toggleDragModeOnDblclick: true,
    // Size limitation
    minCanvasWidth: 0,
    minCanvasHeight: 0,
    minCropBoxWidth: 0,
    minCropBoxHeight: 0,
    minContainerWidth: 200,
    minContainerHeight: 100,
    // Shortcuts of events
    ready: null,
    cropstart: null,
    cropmove: null,
    cropend: null,
    crop: null,
    zoom: null
  };

  var TEMPLATE = '<div class="cropper-container" touch-action="none">' + '<div class="cropper-wrap-box">' + '<div class="cropper-canvas"></div>' + '</div>' + '<div class="cropper-drag-box"></div>' + '<div class="cropper-crop-box">' + '<span class="cropper-view-box"></span>' + '<span class="cropper-dashed dashed-h"></span>' + '<span class="cropper-dashed dashed-v"></span>' + '<span class="cropper-center"></span>' + '<span class="cropper-face"></span>' + '<span class="cropper-line line-e" data-cropper-action="e"></span>' + '<span class="cropper-line line-n" data-cropper-action="n"></span>' + '<span class="cropper-line line-w" data-cropper-action="w"></span>' + '<span class="cropper-line line-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-e" data-cropper-action="e"></span>' + '<span class="cropper-point point-n" data-cropper-action="n"></span>' + '<span class="cropper-point point-w" data-cropper-action="w"></span>' + '<span class="cropper-point point-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-ne" data-cropper-action="ne"></span>' + '<span class="cropper-point point-nw" data-cropper-action="nw"></span>' + '<span class="cropper-point point-sw" data-cropper-action="sw"></span>' + '<span class="cropper-point point-se" data-cropper-action="se"></span>' + '</div>' + '</div>';

  /**
   * Check if the given value is not a number.
   */

  var isNaN = Number.isNaN || WINDOW.isNaN;
  /**
   * Check if the given value is a number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
   */

  function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }
  /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */

  var isPositiveNumber = function isPositiveNumber(value) {
    return value > 0 && value < Infinity;
  };
  /**
   * Check if the given value is undefined.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
   */

  function isUndefined(value) {
    return typeof value === 'undefined';
  }
  /**
   * Check if the given value is an object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
   */

  function isObject(value) {
    return _typeof(value) === 'object' && value !== null;
  }
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  /**
   * Check if the given value is a plain object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
   */

  function isPlainObject(value) {
    if (!isObject(value)) {
      return false;
    }

    try {
      var _constructor = value.constructor;
      var prototype = _constructor.prototype;
      return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
    } catch (error) {
      return false;
    }
  }
  /**
   * Check if the given value is a function.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
   */

  function isFunction(value) {
    return typeof value === 'function';
  }
  var slice = Array.prototype.slice;
  /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */

  function toArray(value) {
    return Array.from ? Array.from(value) : slice.call(value);
  }
  /**
   * Iterate the given data.
   * @param {*} data - The data to iterate.
   * @param {Function} callback - The process function for each element.
   * @returns {*} The original data.
   */

  function forEach(data, callback) {
    if (data && isFunction(callback)) {
      if (Array.isArray(data) || isNumber(data.length)
      /* array-like */
      ) {
          toArray(data).forEach(function (value, key) {
            callback.call(data, value, key, data);
          });
        } else if (isObject(data)) {
        Object.keys(data).forEach(function (key) {
          callback.call(data, data[key], key, data);
        });
      }
    }

    return data;
  }
  /**
   * Extend the given object.
   * @param {*} target - The target object to extend.
   * @param {*} args - The rest objects for merging to the target object.
   * @returns {Object} The extended object.
   */

  var assign = Object.assign || function assign(target) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (isObject(target) && args.length > 0) {
      args.forEach(function (arg) {
        if (isObject(arg)) {
          Object.keys(arg).forEach(function (key) {
            target[key] = arg[key];
          });
        }
      });
    }

    return target;
  };
  var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
  /**
   * Normalize decimal number.
   * Check out {@link http://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */

  function normalizeDecimalNumber(value) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
    return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
  }
  var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
  /**
   * Apply styles to the given element.
   * @param {Element} element - The target element.
   * @param {Object} styles - The styles for applying.
   */

  function setStyle(element, styles) {
    var style = element.style;
    forEach(styles, function (value, property) {
      if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
        value = "".concat(value, "px");
      }

      style[property] = value;
    });
  }
  /**
   * Check if the given element has a special class.
   * @param {Element} element - The element to check.
   * @param {string} value - The class to search.
   * @returns {boolean} Returns `true` if the special class was found.
   */

  function hasClass(element, value) {
    return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
  }
  /**
   * Add classes to the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be added.
   */

  function addClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        addClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.add(value);
      return;
    }

    var className = element.className.trim();

    if (!className) {
      element.className = value;
    } else if (className.indexOf(value) < 0) {
      element.className = "".concat(className, " ").concat(value);
    }
  }
  /**
   * Remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be removed.
   */

  function removeClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        removeClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.remove(value);
      return;
    }

    if (element.className.indexOf(value) >= 0) {
      element.className = element.className.replace(value, '');
    }
  }
  /**
   * Add or remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be toggled.
   * @param {boolean} added - Add only.
   */

  function toggleClass(element, value, added) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        toggleClass(elem, value, added);
      });
      return;
    } // IE10-11 doesn't support the second parameter of `classList.toggle`


    if (added) {
      addClass(element, value);
    } else {
      removeClass(element, value);
    }
  }
  var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
  /**
   * Transform the given string from camelCase to kebab-case
   * @param {string} value - The value to transform.
   * @returns {string} The transformed value.
   */

  function toParamCase(value) {
    return value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
  }
  /**
   * Get data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to get.
   * @returns {string} The data value.
   */

  function getData(element, name) {
    if (isObject(element[name])) {
      return element[name];
    }

    if (element.dataset) {
      return element.dataset[name];
    }

    return element.getAttribute("data-".concat(toParamCase(name)));
  }
  /**
   * Set data to the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to set.
   * @param {string} data - The data value.
   */

  function setData(element, name, data) {
    if (isObject(data)) {
      element[name] = data;
    } else if (element.dataset) {
      element.dataset[name] = data;
    } else {
      element.setAttribute("data-".concat(toParamCase(name)), data);
    }
  }
  /**
   * Remove data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to remove.
   */

  function removeData(element, name) {
    if (isObject(element[name])) {
      try {
        delete element[name];
      } catch (error) {
        element[name] = undefined;
      }
    } else if (element.dataset) {
      // #128 Safari not allows to delete dataset property
      try {
        delete element.dataset[name];
      } catch (error) {
        element.dataset[name] = undefined;
      }
    } else {
      element.removeAttribute("data-".concat(toParamCase(name)));
    }
  }
  var REGEXP_SPACES = /\s\s*/;

  var onceSupported = function () {
    var supported = false;

    if (IS_BROWSER) {
      var once = false;

      var listener = function listener() {};

      var options = Object.defineProperty({}, 'once', {
        get: function get() {
          supported = true;
          return once;
        },

        /**
         * This setter can fix a `TypeError` in strict mode
         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
         * @param {boolean} value - The value to set
         */
        set: function set(value) {
          once = value;
        }
      });
      WINDOW.addEventListener('test', listener, options);
      WINDOW.removeEventListener('test', listener, options);
    }

    return supported;
  }();
  /**
   * Remove event listener from the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */


  function removeListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (!onceSupported) {
        var listeners = element.listeners;

        if (listeners && listeners[event] && listeners[event][listener]) {
          handler = listeners[event][listener];
          delete listeners[event][listener];

          if (Object.keys(listeners[event]).length === 0) {
            delete listeners[event];
          }

          if (Object.keys(listeners).length === 0) {
            delete element.listeners;
          }
        }
      }

      element.removeEventListener(event, handler, options);
    });
  }
  /**
   * Add event listener to the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */

  function addListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (options.once && !onceSupported) {
        var _element$listeners = element.listeners,
            listeners = _element$listeners === void 0 ? {} : _element$listeners;

        _handler = function handler() {
          delete listeners[event][listener];
          element.removeEventListener(event, _handler, options);

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          listener.apply(element, args);
        };

        if (!listeners[event]) {
          listeners[event] = {};
        }

        if (listeners[event][listener]) {
          element.removeEventListener(event, listeners[event][listener], options);
        }

        listeners[event][listener] = _handler;
        element.listeners = listeners;
      }

      element.addEventListener(event, _handler, options);
    });
  }
  /**
   * Dispatch event on the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Object} data - The additional event data.
   * @returns {boolean} Indicate if the event is default prevented or not.
   */

  function dispatchEvent(element, type, data) {
    var event; // Event and CustomEvent on IE9-11 are global objects, not constructors

    if (isFunction(Event) && isFunction(CustomEvent)) {
      event = new CustomEvent(type, {
        detail: data,
        bubbles: true,
        cancelable: true
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(type, true, true, data);
    }

    return element.dispatchEvent(event);
  }
  /**
   * Get the offset base on the document.
   * @param {Element} element - The target element.
   * @returns {Object} The offset data.
   */

  function getOffset(element) {
    var box = element.getBoundingClientRect();
    return {
      left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
      top: box.top + (window.pageYOffset - document.documentElement.clientTop)
    };
  }
  var location = WINDOW.location;
  var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
  /**
   * Check if the given URL is a cross origin URL.
   * @param {string} url - The target URL.
   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
   */

  function isCrossOriginURL(url) {
    var parts = url.match(REGEXP_ORIGINS);
    return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
  }
  /**
   * Add timestamp to the given URL.
   * @param {string} url - The target URL.
   * @returns {string} The result URL.
   */

  function addTimestamp(url) {
    var timestamp = "timestamp=".concat(new Date().getTime());
    return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
  }
  /**
   * Get transforms base on the given object.
   * @param {Object} obj - The target object.
   * @returns {string} A string contains transform values.
   */

  function getTransforms(_ref) {
    var rotate = _ref.rotate,
        scaleX = _ref.scaleX,
        scaleY = _ref.scaleY,
        translateX = _ref.translateX,
        translateY = _ref.translateY;
    var values = [];

    if (isNumber(translateX) && translateX !== 0) {
      values.push("translateX(".concat(translateX, "px)"));
    }

    if (isNumber(translateY) && translateY !== 0) {
      values.push("translateY(".concat(translateY, "px)"));
    } // Rotate should come first before scale to match orientation transform


    if (isNumber(rotate) && rotate !== 0) {
      values.push("rotate(".concat(rotate, "deg)"));
    }

    if (isNumber(scaleX) && scaleX !== 1) {
      values.push("scaleX(".concat(scaleX, ")"));
    }

    if (isNumber(scaleY) && scaleY !== 1) {
      values.push("scaleY(".concat(scaleY, ")"));
    }

    var transform = values.length ? values.join(' ') : 'none';
    return {
      WebkitTransform: transform,
      msTransform: transform,
      transform: transform
    };
  }
  /**
   * Get the max ratio of a group of pointers.
   * @param {string} pointers - The target pointers.
   * @returns {number} The result ratio.
   */

  function getMaxZoomRatio(pointers) {
    var pointers2 = assign({}, pointers);
    var ratios = [];
    forEach(pointers, function (pointer, pointerId) {
      delete pointers2[pointerId];
      forEach(pointers2, function (pointer2) {
        var x1 = Math.abs(pointer.startX - pointer2.startX);
        var y1 = Math.abs(pointer.startY - pointer2.startY);
        var x2 = Math.abs(pointer.endX - pointer2.endX);
        var y2 = Math.abs(pointer.endY - pointer2.endY);
        var z1 = Math.sqrt(x1 * x1 + y1 * y1);
        var z2 = Math.sqrt(x2 * x2 + y2 * y2);
        var ratio = (z2 - z1) / z1;
        ratios.push(ratio);
      });
    });
    ratios.sort(function (a, b) {
      return Math.abs(a) < Math.abs(b);
    });
    return ratios[0];
  }
  /**
   * Get a pointer from an event object.
   * @param {Object} event - The target event object.
   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
   * @returns {Object} The result pointer contains start and/or end point coordinates.
   */

  function getPointer(_ref2, endOnly) {
    var pageX = _ref2.pageX,
        pageY = _ref2.pageY;
    var end = {
      endX: pageX,
      endY: pageY
    };
    return endOnly ? end : assign({
      startX: pageX,
      startY: pageY
    }, end);
  }
  /**
   * Get the center point coordinate of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {Object} The center point coordinate.
   */

  function getPointersCenter(pointers) {
    var pageX = 0;
    var pageY = 0;
    var count = 0;
    forEach(pointers, function (_ref3) {
      var startX = _ref3.startX,
          startY = _ref3.startY;
      pageX += startX;
      pageY += startY;
      count += 1;
    });
    pageX /= count;
    pageY /= count;
    return {
      pageX: pageX,
      pageY: pageY
    };
  }
  /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */

  function getAdjustedSizes(_ref4) // or 'cover'
  {
    var aspectRatio = _ref4.aspectRatio,
        height = _ref4.height,
        width = _ref4.width;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
    var isValidWidth = isPositiveNumber(width);
    var isValidHeight = isPositiveNumber(height);

    if (isValidWidth && isValidHeight) {
      var adjustedWidth = height * aspectRatio;

      if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
        height = width / aspectRatio;
      } else {
        width = height * aspectRatio;
      }
    } else if (isValidWidth) {
      height = width / aspectRatio;
    } else if (isValidHeight) {
      width = height * aspectRatio;
    }

    return {
      width: width,
      height: height
    };
  }
  /**
   * Get the new sizes of a rectangle after rotated.
   * @param {Object} data - The original sizes.
   * @returns {Object} The result sizes.
   */

  function getRotatedSizes(_ref5) {
    var width = _ref5.width,
        height = _ref5.height,
        degree = _ref5.degree;
    degree = Math.abs(degree) % 180;

    if (degree === 90) {
      return {
        width: height,
        height: width
      };
    }

    var arc = degree % 90 * Math.PI / 180;
    var sinArc = Math.sin(arc);
    var cosArc = Math.cos(arc);
    var newWidth = width * cosArc + height * sinArc;
    var newHeight = width * sinArc + height * cosArc;
    return degree > 90 ? {
      width: newHeight,
      height: newWidth
    } : {
      width: newWidth,
      height: newHeight
    };
  }
  /**
   * Get a canvas which drew the given image.
   * @param {HTMLImageElement} image - The image for drawing.
   * @param {Object} imageData - The image data.
   * @param {Object} canvasData - The canvas data.
   * @param {Object} options - The options.
   * @returns {HTMLCanvasElement} The result canvas.
   */

  function getSourceCanvas(image, _ref6, _ref7, _ref8) {
    var imageAspectRatio = _ref6.aspectRatio,
        imageNaturalWidth = _ref6.naturalWidth,
        imageNaturalHeight = _ref6.naturalHeight,
        _ref6$rotate = _ref6.rotate,
        rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate,
        _ref6$scaleX = _ref6.scaleX,
        scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX,
        _ref6$scaleY = _ref6.scaleY,
        scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
    var aspectRatio = _ref7.aspectRatio,
        naturalWidth = _ref7.naturalWidth,
        naturalHeight = _ref7.naturalHeight;
    var _ref8$fillColor = _ref8.fillColor,
        fillColor = _ref8$fillColor === void 0 ? 'transparent' : _ref8$fillColor,
        _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled,
        imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE,
        _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality,
        imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? 'low' : _ref8$imageSmoothingQ,
        _ref8$maxWidth = _ref8.maxWidth,
        maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth,
        _ref8$maxHeight = _ref8.maxHeight,
        maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight,
        _ref8$minWidth = _ref8.minWidth,
        minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth,
        _ref8$minHeight = _ref8.minHeight,
        minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    var maxSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var minSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
    var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight)); // Note: should always use image's natural sizes for drawing as
    // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90

    var destMaxSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var destMinSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
    var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
    var params = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];
    canvas.width = normalizeDecimalNumber(width);
    canvas.height = normalizeDecimalNumber(height);
    context.fillStyle = fillColor;
    context.fillRect(0, 0, width, height);
    context.save();
    context.translate(width / 2, height / 2);
    context.rotate(rotate * Math.PI / 180);
    context.scale(scaleX, scaleY);
    context.imageSmoothingEnabled = imageSmoothingEnabled;
    context.imageSmoothingQuality = imageSmoothingQuality;
    context.drawImage.apply(context, [image].concat(_toConsumableArray(params.map(function (param) {
      return Math.floor(normalizeDecimalNumber(param));
    }))));
    context.restore();
    return canvas;
  }
  var fromCharCode = String.fromCharCode;
  /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */

  function getStringFromCharCode(dataView, start, length) {
    var str = '';
    length += start;

    for (var i = start; i < length; i += 1) {
      str += fromCharCode(dataView.getUint8(i));
    }

    return str;
  }
  var REGEXP_DATA_URL_HEAD = /^data:.*,/;
  /**
   * Transform Data URL to array buffer.
   * @param {string} dataURL - The Data URL to transform.
   * @returns {ArrayBuffer} The result array buffer.
   */

  function dataURLToArrayBuffer(dataURL) {
    var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
    var binary = atob(base64);
    var arrayBuffer = new ArrayBuffer(binary.length);
    var uint8 = new Uint8Array(arrayBuffer);
    forEach(uint8, function (value, i) {
      uint8[i] = binary.charCodeAt(i);
    });
    return arrayBuffer;
  }
  /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */

  function arrayBufferToDataURL(arrayBuffer, mimeType) {
    var chunks = []; // Chunk Typed Array for better performance (#435)

    var chunkSize = 8192;
    var uint8 = new Uint8Array(arrayBuffer);

    while (uint8.length > 0) {
      // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
      // eslint-disable-next-line prefer-spread
      chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
      uint8 = uint8.subarray(chunkSize);
    }

    return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
  }
  /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */

  function resetAndGetOrientation(arrayBuffer) {
    var dataView = new DataView(arrayBuffer);
    var orientation; // Ignores range error when the image does not have correct Exif information

    try {
      var littleEndian;
      var app1Start;
      var ifdStart; // Only handle JPEG image (start by 0xFFD8)

      if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
        var length = dataView.byteLength;
        var offset = 2;

        while (offset + 1 < length) {
          if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
            app1Start = offset;
            break;
          }

          offset += 1;
        }
      }

      if (app1Start) {
        var exifIDCode = app1Start + 4;
        var tiffOffset = app1Start + 10;

        if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
          var endianness = dataView.getUint16(tiffOffset);
          littleEndian = endianness === 0x4949;

          if (littleEndian || endianness === 0x4D4D
          /* bigEndian */
          ) {
              if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

                if (firstIFDOffset >= 0x00000008) {
                  ifdStart = tiffOffset + firstIFDOffset;
                }
              }
            }
        }
      }

      if (ifdStart) {
        var _length = dataView.getUint16(ifdStart, littleEndian);

        var _offset;

        var i;

        for (i = 0; i < _length; i += 1) {
          _offset = ifdStart + i * 12 + 2;

          if (dataView.getUint16(_offset, littleEndian) === 0x0112
          /* Orientation */
          ) {
              // 8 is the offset of the current tag's value
              _offset += 8; // Get the original orientation value

              orientation = dataView.getUint16(_offset, littleEndian); // Override the orientation with its default value

              dataView.setUint16(_offset, 1, littleEndian);
              break;
            }
        }
      }
    } catch (error) {
      orientation = 1;
    }

    return orientation;
  }
  /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */

  function parseOrientation(orientation) {
    var rotate = 0;
    var scaleX = 1;
    var scaleY = 1;

    switch (orientation) {
      // Flip horizontal
      case 2:
        scaleX = -1;
        break;
      // Rotate left 180°

      case 3:
        rotate = -180;
        break;
      // Flip vertical

      case 4:
        scaleY = -1;
        break;
      // Flip vertical and rotate right 90°

      case 5:
        rotate = 90;
        scaleY = -1;
        break;
      // Rotate right 90°

      case 6:
        rotate = 90;
        break;
      // Flip horizontal and rotate right 90°

      case 7:
        rotate = 90;
        scaleX = -1;
        break;
      // Rotate left 90°

      case 8:
        rotate = -90;
        break;

      default:
    }

    return {
      rotate: rotate,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }

  var render = {
    render: function render() {
      this.initContainer();
      this.initCanvas();
      this.initCropBox();
      this.renderCanvas();

      if (this.cropped) {
        this.renderCropBox();
      }
    },
    initContainer: function initContainer() {
      var element = this.element,
          options = this.options,
          container = this.container,
          cropper = this.cropper;
      addClass(cropper, CLASS_HIDDEN);
      removeClass(element, CLASS_HIDDEN);
      var containerData = {
        width: Math.max(container.offsetWidth, Number(options.minContainerWidth) || 200),
        height: Math.max(container.offsetHeight, Number(options.minContainerHeight) || 100)
      };
      this.containerData = containerData;
      setStyle(cropper, {
        width: containerData.width,
        height: containerData.height
      });
      addClass(element, CLASS_HIDDEN);
      removeClass(cropper, CLASS_HIDDEN);
    },
    // Canvas (image wrapper)
    initCanvas: function initCanvas() {
      var containerData = this.containerData,
          imageData = this.imageData;
      var viewMode = this.options.viewMode;
      var rotated = Math.abs(imageData.rotate) % 180 === 90;
      var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
      var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
      var aspectRatio = naturalWidth / naturalHeight;
      var canvasWidth = containerData.width;
      var canvasHeight = containerData.height;

      if (containerData.height * aspectRatio > containerData.width) {
        if (viewMode === 3) {
          canvasWidth = containerData.height * aspectRatio;
        } else {
          canvasHeight = containerData.width / aspectRatio;
        }
      } else if (viewMode === 3) {
        canvasHeight = containerData.width / aspectRatio;
      } else {
        canvasWidth = containerData.height * aspectRatio;
      }

      var canvasData = {
        aspectRatio: aspectRatio,
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight,
        width: canvasWidth,
        height: canvasHeight
      };
      canvasData.left = (containerData.width - canvasWidth) / 2;
      canvasData.top = (containerData.height - canvasHeight) / 2;
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      this.canvasData = canvasData;
      this.limited = viewMode === 1 || viewMode === 2;
      this.limitCanvas(true, true);
      this.initialImageData = assign({}, imageData);
      this.initialCanvasData = assign({}, canvasData);
    },
    limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
      var options = this.options,
          containerData = this.containerData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var viewMode = options.viewMode;
      var aspectRatio = canvasData.aspectRatio;
      var cropped = this.cropped && cropBoxData;

      if (sizeLimited) {
        var minCanvasWidth = Number(options.minCanvasWidth) || 0;
        var minCanvasHeight = Number(options.minCanvasHeight) || 0;

        if (viewMode > 1) {
          minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
          minCanvasHeight = Math.max(minCanvasHeight, containerData.height);

          if (viewMode === 3) {
            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        } else if (viewMode > 0) {
          if (minCanvasWidth) {
            minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
          } else if (minCanvasHeight) {
            minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
          } else if (cropped) {
            minCanvasWidth = cropBoxData.width;
            minCanvasHeight = cropBoxData.height;

            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        }

        var _getAdjustedSizes = getAdjustedSizes({
          aspectRatio: aspectRatio,
          width: minCanvasWidth,
          height: minCanvasHeight
        });

        minCanvasWidth = _getAdjustedSizes.width;
        minCanvasHeight = _getAdjustedSizes.height;
        canvasData.minWidth = minCanvasWidth;
        canvasData.minHeight = minCanvasHeight;
        canvasData.maxWidth = Infinity;
        canvasData.maxHeight = Infinity;
      }

      if (positionLimited) {
        if (viewMode > (cropped ? 0 : 1)) {
          var newCanvasLeft = containerData.width - canvasData.width;
          var newCanvasTop = containerData.height - canvasData.height;
          canvasData.minLeft = Math.min(0, newCanvasLeft);
          canvasData.minTop = Math.min(0, newCanvasTop);
          canvasData.maxLeft = Math.max(0, newCanvasLeft);
          canvasData.maxTop = Math.max(0, newCanvasTop);

          if (cropped && this.limited) {
            canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
            canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
            canvasData.maxLeft = cropBoxData.left;
            canvasData.maxTop = cropBoxData.top;

            if (viewMode === 2) {
              if (canvasData.width >= containerData.width) {
                canvasData.minLeft = Math.min(0, newCanvasLeft);
                canvasData.maxLeft = Math.max(0, newCanvasLeft);
              }

              if (canvasData.height >= containerData.height) {
                canvasData.minTop = Math.min(0, newCanvasTop);
                canvasData.maxTop = Math.max(0, newCanvasTop);
              }
            }
          }
        } else {
          canvasData.minLeft = -canvasData.width;
          canvasData.minTop = -canvasData.height;
          canvasData.maxLeft = containerData.width;
          canvasData.maxTop = containerData.height;
        }
      }
    },
    renderCanvas: function renderCanvas(changed, transformed) {
      var canvasData = this.canvasData,
          imageData = this.imageData;

      if (transformed) {
        var _getRotatedSizes = getRotatedSizes({
          width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
          height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
          degree: imageData.rotate || 0
        }),
            naturalWidth = _getRotatedSizes.width,
            naturalHeight = _getRotatedSizes.height;

        var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
        var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
        canvasData.left -= (width - canvasData.width) / 2;
        canvasData.top -= (height - canvasData.height) / 2;
        canvasData.width = width;
        canvasData.height = height;
        canvasData.aspectRatio = naturalWidth / naturalHeight;
        canvasData.naturalWidth = naturalWidth;
        canvasData.naturalHeight = naturalHeight;
        this.limitCanvas(true, false);
      }

      if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) {
        canvasData.left = canvasData.oldLeft;
      }

      if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) {
        canvasData.top = canvasData.oldTop;
      }

      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
      this.limitCanvas(false, true);
      canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
      canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      setStyle(this.canvas, assign({
        width: canvasData.width,
        height: canvasData.height
      }, getTransforms({
        translateX: canvasData.left,
        translateY: canvasData.top
      })));
      this.renderImage(changed);

      if (this.cropped && this.limited) {
        this.limitCropBox(true, true);
      }
    },
    renderImage: function renderImage(changed) {
      var canvasData = this.canvasData,
          imageData = this.imageData;
      var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
      var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
      assign(imageData, {
        width: width,
        height: height,
        left: (canvasData.width - width) / 2,
        top: (canvasData.height - height) / 2
      });
      setStyle(this.image, assign({
        width: imageData.width,
        height: imageData.height
      }, getTransforms(assign({
        translateX: imageData.left,
        translateY: imageData.top
      }, imageData))));

      if (changed) {
        this.output();
      }
    },
    initCropBox: function initCropBox() {
      var options = this.options,
          canvasData = this.canvasData;
      var aspectRatio = options.aspectRatio || options.initialAspectRatio;
      var autoCropArea = Number(options.autoCropArea) || 0.8;
      var cropBoxData = {
        width: canvasData.width,
        height: canvasData.height
      };

      if (aspectRatio) {
        if (canvasData.height * aspectRatio > canvasData.width) {
          cropBoxData.height = cropBoxData.width / aspectRatio;
        } else {
          cropBoxData.width = cropBoxData.height * aspectRatio;
        }
      }

      this.cropBoxData = cropBoxData;
      this.limitCropBox(true, true); // Initialize auto crop area

      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight); // The width/height of auto crop area must large than "minWidth/Height"

      cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
      cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
      cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
      cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;
      this.initialCropBoxData = assign({}, cropBoxData);
    },
    limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
      var options = this.options,
          containerData = this.containerData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData,
          limited = this.limited;
      var aspectRatio = options.aspectRatio;

      if (sizeLimited) {
        var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
        var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
        var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
        var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height; // The min/maxCropBoxWidth/Height must be less than container's width/height

        minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
        minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);

        if (aspectRatio) {
          if (minCropBoxWidth && minCropBoxHeight) {
            if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
              minCropBoxHeight = minCropBoxWidth / aspectRatio;
            } else {
              minCropBoxWidth = minCropBoxHeight * aspectRatio;
            }
          } else if (minCropBoxWidth) {
            minCropBoxHeight = minCropBoxWidth / aspectRatio;
          } else if (minCropBoxHeight) {
            minCropBoxWidth = minCropBoxHeight * aspectRatio;
          }

          if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
            maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
          } else {
            maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
          }
        } // The minWidth/Height must be less than maxWidth/Height


        cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
        cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
        cropBoxData.maxWidth = maxCropBoxWidth;
        cropBoxData.maxHeight = maxCropBoxHeight;
      }

      if (positionLimited) {
        if (limited) {
          cropBoxData.minLeft = Math.max(0, canvasData.left);
          cropBoxData.minTop = Math.max(0, canvasData.top);
          cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
          cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
        } else {
          cropBoxData.minLeft = 0;
          cropBoxData.minTop = 0;
          cropBoxData.maxLeft = containerData.width - cropBoxData.width;
          cropBoxData.maxTop = containerData.height - cropBoxData.height;
        }
      }
    },
    renderCropBox: function renderCropBox() {
      var options = this.options,
          containerData = this.containerData,
          cropBoxData = this.cropBoxData;

      if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) {
        cropBoxData.left = cropBoxData.oldLeft;
      }

      if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) {
        cropBoxData.top = cropBoxData.oldTop;
      }

      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
      this.limitCropBox(false, true);
      cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
      cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;

      if (options.movable && options.cropBoxMovable) {
        // Turn to move the canvas when the crop box is equal to the container
        setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
      }

      setStyle(this.cropBox, assign({
        width: cropBoxData.width,
        height: cropBoxData.height
      }, getTransforms({
        translateX: cropBoxData.left,
        translateY: cropBoxData.top
      })));

      if (this.cropped && this.limited) {
        this.limitCanvas(true, true);
      }

      if (!this.disabled) {
        this.output();
      }
    },
    output: function output() {
      this.preview();
      dispatchEvent(this.element, EVENT_CROP, this.getData());
    }
  };

  var preview = {
    initPreview: function initPreview() {
      var element = this.element,
          crossOrigin = this.crossOrigin;
      var preview = this.options.preview;
      var url = crossOrigin ? this.crossOriginUrl : this.url;
      var alt = element.alt || 'The image to preview';
      var image = document.createElement('img');

      if (crossOrigin) {
        image.crossOrigin = crossOrigin;
      }

      image.src = url;
      image.alt = alt;
      this.viewBox.appendChild(image);
      this.viewBoxImage = image;

      if (!preview) {
        return;
      }

      var previews = preview;

      if (typeof preview === 'string') {
        previews = element.ownerDocument.querySelectorAll(preview);
      } else if (preview.querySelector) {
        previews = [preview];
      }

      this.previews = previews;
      forEach(previews, function (el) {
        var img = document.createElement('img'); // Save the original size for recover

        setData(el, DATA_PREVIEW, {
          width: el.offsetWidth,
          height: el.offsetHeight,
          html: el.innerHTML
        });

        if (crossOrigin) {
          img.crossOrigin = crossOrigin;
        }

        img.src = url;
        img.alt = alt;
        /**
         * Override img element styles
         * Add `display:block` to avoid margin top issue
         * Add `height:auto` to override `height` attribute on IE8
         * (Occur only when margin-top <= -height)
         */

        img.style.cssText = 'display:block;' + 'width:100%;' + 'height:auto;' + 'min-width:0!important;' + 'min-height:0!important;' + 'max-width:none!important;' + 'max-height:none!important;' + 'image-orientation:0deg!important;"';
        el.innerHTML = '';
        el.appendChild(img);
      });
    },
    resetPreview: function resetPreview() {
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        setStyle(element, {
          width: data.width,
          height: data.height
        });
        element.innerHTML = data.html;
        removeData(element, DATA_PREVIEW);
      });
    },
    preview: function preview() {
      var imageData = this.imageData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var cropBoxWidth = cropBoxData.width,
          cropBoxHeight = cropBoxData.height;
      var width = imageData.width,
          height = imageData.height;
      var left = cropBoxData.left - canvasData.left - imageData.left;
      var top = cropBoxData.top - canvasData.top - imageData.top;

      if (!this.cropped || this.disabled) {
        return;
      }

      setStyle(this.viewBoxImage, assign({
        width: width,
        height: height
      }, getTransforms(assign({
        translateX: -left,
        translateY: -top
      }, imageData))));
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        var originalWidth = data.width;
        var originalHeight = data.height;
        var newWidth = originalWidth;
        var newHeight = originalHeight;
        var ratio = 1;

        if (cropBoxWidth) {
          ratio = originalWidth / cropBoxWidth;
          newHeight = cropBoxHeight * ratio;
        }

        if (cropBoxHeight && newHeight > originalHeight) {
          ratio = originalHeight / cropBoxHeight;
          newWidth = cropBoxWidth * ratio;
          newHeight = originalHeight;
        }

        setStyle(element, {
          width: newWidth,
          height: newHeight
        });
        setStyle(element.getElementsByTagName('img')[0], assign({
          width: width * ratio,
          height: height * ratio
        }, getTransforms(assign({
          translateX: -left * ratio,
          translateY: -top * ratio
        }, imageData))));
      });
    }
  };

  var events = {
    bind: function bind() {
      var element = this.element,
          options = this.options,
          cropper = this.cropper;

      if (isFunction(options.cropstart)) {
        addListener(element, EVENT_CROP_START, options.cropstart);
      }

      if (isFunction(options.cropmove)) {
        addListener(element, EVENT_CROP_MOVE, options.cropmove);
      }

      if (isFunction(options.cropend)) {
        addListener(element, EVENT_CROP_END, options.cropend);
      }

      if (isFunction(options.crop)) {
        addListener(element, EVENT_CROP, options.crop);
      }

      if (isFunction(options.zoom)) {
        addListener(element, EVENT_ZOOM, options.zoom);
      }

      addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));

      if (options.zoomable && options.zoomOnWheel) {
        addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
          passive: false,
          capture: true
        });
      }

      if (options.toggleDragModeOnDblclick) {
        addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
      }

      addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
      addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));

      if (options.responsive) {
        addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
      }
    },
    unbind: function unbind() {
      var element = this.element,
          options = this.options,
          cropper = this.cropper;

      if (isFunction(options.cropstart)) {
        removeListener(element, EVENT_CROP_START, options.cropstart);
      }

      if (isFunction(options.cropmove)) {
        removeListener(element, EVENT_CROP_MOVE, options.cropmove);
      }

      if (isFunction(options.cropend)) {
        removeListener(element, EVENT_CROP_END, options.cropend);
      }

      if (isFunction(options.crop)) {
        removeListener(element, EVENT_CROP, options.crop);
      }

      if (isFunction(options.zoom)) {
        removeListener(element, EVENT_ZOOM, options.zoom);
      }

      removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);

      if (options.zoomable && options.zoomOnWheel) {
        removeListener(cropper, EVENT_WHEEL, this.onWheel, {
          passive: false,
          capture: true
        });
      }

      if (options.toggleDragModeOnDblclick) {
        removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
      }

      removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
      removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);

      if (options.responsive) {
        removeListener(window, EVENT_RESIZE, this.onResize);
      }
    }
  };

  var handlers = {
    resize: function resize() {
      var options = this.options,
          container = this.container,
          containerData = this.containerData;
      var minContainerWidth = Number(options.minContainerWidth) || MIN_CONTAINER_WIDTH;
      var minContainerHeight = Number(options.minContainerHeight) || MIN_CONTAINER_HEIGHT;

      if (this.disabled || containerData.width <= minContainerWidth || containerData.height <= minContainerHeight) {
        return;
      }

      var ratio = container.offsetWidth / containerData.width; // Resize when width changed or height changed

      if (ratio !== 1 || container.offsetHeight !== containerData.height) {
        var canvasData;
        var cropBoxData;

        if (options.restore) {
          canvasData = this.getCanvasData();
          cropBoxData = this.getCropBoxData();
        }

        this.render();

        if (options.restore) {
          this.setCanvasData(forEach(canvasData, function (n, i) {
            canvasData[i] = n * ratio;
          }));
          this.setCropBoxData(forEach(cropBoxData, function (n, i) {
            cropBoxData[i] = n * ratio;
          }));
        }
      }
    },
    dblclick: function dblclick() {
      if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) {
        return;
      }

      this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
    },
    wheel: function wheel(event) {
      var _this = this;

      var ratio = Number(this.options.wheelZoomRatio) || 0.1;
      var delta = 1;

      if (this.disabled) {
        return;
      }

      event.preventDefault(); // Limit wheel speed to prevent zoom too fast (#21)

      if (this.wheeling) {
        return;
      }

      this.wheeling = true;
      setTimeout(function () {
        _this.wheeling = false;
      }, 50);

      if (event.deltaY) {
        delta = event.deltaY > 0 ? 1 : -1;
      } else if (event.wheelDelta) {
        delta = -event.wheelDelta / 120;
      } else if (event.detail) {
        delta = event.detail > 0 ? 1 : -1;
      }

      this.zoom(-delta * ratio, event);
    },
    cropStart: function cropStart(event) {
      var buttons = event.buttons,
          button = event.button;

      if (this.disabled // No primary button (Usually the left button)
      // Note that touch events have no `buttons` or `button` property
      || isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 // Open context menu
      || event.ctrlKey) {
        return;
      }

      var options = this.options,
          pointers = this.pointers;
      var action;

      if (event.changedTouches) {
        // Handle touch event
        forEach(event.changedTouches, function (touch) {
          pointers[touch.identifier] = getPointer(touch);
        });
      } else {
        // Handle mouse event and pointer event
        pointers[event.pointerId || 0] = getPointer(event);
      }

      if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) {
        action = ACTION_ZOOM;
      } else {
        action = getData(event.target, DATA_ACTION);
      }

      if (!REGEXP_ACTIONS.test(action)) {
        return;
      }

      if (dispatchEvent(this.element, EVENT_CROP_START, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      } // This line is required for preventing page zooming in iOS browsers


      event.preventDefault();
      this.action = action;
      this.cropping = false;

      if (action === ACTION_CROP) {
        this.cropping = true;
        addClass(this.dragBox, CLASS_MODAL);
      }
    },
    cropMove: function cropMove(event) {
      var action = this.action;

      if (this.disabled || !action) {
        return;
      }

      var pointers = this.pointers;
      event.preventDefault();

      if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      }

      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          // The first parameter should not be undefined (#432)
          assign(pointers[touch.identifier] || {}, getPointer(touch, true));
        });
      } else {
        assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
      }

      this.change(event);
    },
    cropEnd: function cropEnd(event) {
      if (this.disabled) {
        return;
      }

      var action = this.action,
          pointers = this.pointers;

      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          delete pointers[touch.identifier];
        });
      } else {
        delete pointers[event.pointerId || 0];
      }

      if (!action) {
        return;
      }

      event.preventDefault();

      if (!Object.keys(pointers).length) {
        this.action = '';
      }

      if (this.cropping) {
        this.cropping = false;
        toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
      }

      dispatchEvent(this.element, EVENT_CROP_END, {
        originalEvent: event,
        action: action
      });
    }
  };

  var change = {
    change: function change(event) {
      var options = this.options,
          canvasData = this.canvasData,
          containerData = this.containerData,
          cropBoxData = this.cropBoxData,
          pointers = this.pointers;
      var action = this.action;
      var aspectRatio = options.aspectRatio;
      var left = cropBoxData.left,
          top = cropBoxData.top,
          width = cropBoxData.width,
          height = cropBoxData.height;
      var right = left + width;
      var bottom = top + height;
      var minLeft = 0;
      var minTop = 0;
      var maxWidth = containerData.width;
      var maxHeight = containerData.height;
      var renderable = true;
      var offset; // Locking aspect ratio in "free mode" by holding shift key

      if (!aspectRatio && event.shiftKey) {
        aspectRatio = width && height ? width / height : 1;
      }

      if (this.limited) {
        minLeft = cropBoxData.minLeft;
        minTop = cropBoxData.minTop;
        maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
        maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
      }

      var pointer = pointers[Object.keys(pointers)[0]];
      var range = {
        x: pointer.endX - pointer.startX,
        y: pointer.endY - pointer.startY
      };

      var check = function check(side) {
        switch (side) {
          case ACTION_EAST:
            if (right + range.x > maxWidth) {
              range.x = maxWidth - right;
            }

            break;

          case ACTION_WEST:
            if (left + range.x < minLeft) {
              range.x = minLeft - left;
            }

            break;

          case ACTION_NORTH:
            if (top + range.y < minTop) {
              range.y = minTop - top;
            }

            break;

          case ACTION_SOUTH:
            if (bottom + range.y > maxHeight) {
              range.y = maxHeight - bottom;
            }

            break;

          default:
        }
      };

      switch (action) {
        // Move crop box
        case ACTION_ALL:
          left += range.x;
          top += range.y;
          break;
        // Resize crop box

        case ACTION_EAST:
          if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }

          check(ACTION_EAST);
          width += range.x;

          if (width < 0) {
            action = ACTION_WEST;
            width = -width;
            left -= width;
          }

          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }

          break;

        case ACTION_NORTH:
          if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }

          check(ACTION_NORTH);
          height -= range.y;
          top += range.y;

          if (height < 0) {
            action = ACTION_SOUTH;
            height = -height;
            top -= height;
          }

          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }

          break;

        case ACTION_WEST:
          if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }

          check(ACTION_WEST);
          width -= range.x;
          left += range.x;

          if (width < 0) {
            action = ACTION_EAST;
            width = -width;
            left -= width;
          }

          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }

          break;

        case ACTION_SOUTH:
          if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }

          check(ACTION_SOUTH);
          height += range.y;

          if (height < 0) {
            action = ACTION_NORTH;
            height = -height;
            top -= height;
          }

          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }

          break;

        case ACTION_NORTH_EAST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
              renderable = false;
              break;
            }

            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
          } else {
            check(ACTION_NORTH);
            check(ACTION_EAST);

            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_NORTH_WEST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
              renderable = false;
              break;
            }

            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
            left += cropBoxData.width - width;
          } else {
            check(ACTION_NORTH);
            check(ACTION_WEST);

            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_SOUTH_WEST:
          if (aspectRatio) {
            if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            check(ACTION_WEST);
            width -= range.x;
            left += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_WEST);

            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_SOUTH_EAST:
          if (aspectRatio) {
            if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            check(ACTION_EAST);
            width += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_EAST);

            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            top -= height;
          }

          break;
        // Move canvas

        case ACTION_MOVE:
          this.move(range.x, range.y);
          renderable = false;
          break;
        // Zoom canvas

        case ACTION_ZOOM:
          this.zoom(getMaxZoomRatio(pointers), event);
          renderable = false;
          break;
        // Create crop box

        case ACTION_CROP:
          if (!range.x || !range.y) {
            renderable = false;
            break;
          }

          offset = getOffset(this.cropper);
          left = pointer.startX - offset.left;
          top = pointer.startY - offset.top;
          width = cropBoxData.minWidth;
          height = cropBoxData.minHeight;

          if (range.x > 0) {
            action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
          } else if (range.x < 0) {
            left -= width;
            action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
          }

          if (range.y < 0) {
            top -= height;
          } // Show the crop box if is hidden


          if (!this.cropped) {
            removeClass(this.cropBox, CLASS_HIDDEN);
            this.cropped = true;

            if (this.limited) {
              this.limitCropBox(true, true);
            }
          }

          break;

        default:
      }

      if (renderable) {
        cropBoxData.width = width;
        cropBoxData.height = height;
        cropBoxData.left = left;
        cropBoxData.top = top;
        this.action = action;
        this.renderCropBox();
      } // Override


      forEach(pointers, function (p) {
        p.startX = p.endX;
        p.startY = p.endY;
      });
    }
  };

  var methods = {
    // Show the crop box manually
    crop: function crop() {
      if (this.ready && !this.cropped && !this.disabled) {
        this.cropped = true;
        this.limitCropBox(true, true);

        if (this.options.modal) {
          addClass(this.dragBox, CLASS_MODAL);
        }

        removeClass(this.cropBox, CLASS_HIDDEN);
        this.setCropBoxData(this.initialCropBoxData);
      }

      return this;
    },
    // Reset the image and crop box to their initial states
    reset: function reset() {
      if (this.ready && !this.disabled) {
        this.imageData = assign({}, this.initialImageData);
        this.canvasData = assign({}, this.initialCanvasData);
        this.cropBoxData = assign({}, this.initialCropBoxData);
        this.renderCanvas();

        if (this.cropped) {
          this.renderCropBox();
        }
      }

      return this;
    },
    // Clear the crop box
    clear: function clear() {
      if (this.cropped && !this.disabled) {
        assign(this.cropBoxData, {
          left: 0,
          top: 0,
          width: 0,
          height: 0
        });
        this.cropped = false;
        this.renderCropBox();
        this.limitCanvas(true, true); // Render canvas after crop box rendered

        this.renderCanvas();
        removeClass(this.dragBox, CLASS_MODAL);
        addClass(this.cropBox, CLASS_HIDDEN);
      }

      return this;
    },

    /**
     * Replace the image's src and rebuild the cropper
     * @param {string} url - The new URL.
     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
     * @returns {Cropper} this
     */
    replace: function replace(url) {
      var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.disabled && url) {
        if (this.isImg) {
          this.element.src = url;
        }

        if (hasSameSize) {
          this.url = url;
          this.image.src = url;

          if (this.ready) {
            this.viewBoxImage.src = url;
            forEach(this.previews, function (element) {
              element.getElementsByTagName('img')[0].src = url;
            });
          }
        } else {
          if (this.isImg) {
            this.replaced = true;
          }

          this.options.data = null;
          this.uncreate();
          this.load(url);
        }
      }

      return this;
    },
    // Enable (unfreeze) the cropper
    enable: function enable() {
      if (this.ready && this.disabled) {
        this.disabled = false;
        removeClass(this.cropper, CLASS_DISABLED);
      }

      return this;
    },
    // Disable (freeze) the cropper
    disable: function disable() {
      if (this.ready && !this.disabled) {
        this.disabled = true;
        addClass(this.cropper, CLASS_DISABLED);
      }

      return this;
    },

    /**
     * Destroy the cropper and remove the instance from the image
     * @returns {Cropper} this
     */
    destroy: function destroy() {
      var element = this.element;

      if (!element[NAMESPACE]) {
        return this;
      }

      element[NAMESPACE] = undefined;

      if (this.isImg && this.replaced) {
        element.src = this.originalUrl;
      }

      this.uncreate();
      return this;
    },

    /**
     * Move the canvas with relative offsets
     * @param {number} offsetX - The relative offset distance on the x-axis.
     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
     * @returns {Cropper} this
     */
    move: function move(offsetX) {
      var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
      var _this$canvasData = this.canvasData,
          left = _this$canvasData.left,
          top = _this$canvasData.top;
      return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
    },

    /**
     * Move the canvas to an absolute point
     * @param {number} x - The x-axis coordinate.
     * @param {number} [y=x] - The y-axis coordinate.
     * @returns {Cropper} this
     */
    moveTo: function moveTo(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
      var canvasData = this.canvasData;
      var changed = false;
      x = Number(x);
      y = Number(y);

      if (this.ready && !this.disabled && this.options.movable) {
        if (isNumber(x)) {
          canvasData.left = x;
          changed = true;
        }

        if (isNumber(y)) {
          canvasData.top = y;
          changed = true;
        }

        if (changed) {
          this.renderCanvas(true);
        }
      }

      return this;
    },

    /**
     * Zoom the canvas with a relative ratio
     * @param {number} ratio - The target ratio.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoom: function zoom(ratio, _originalEvent) {
      var canvasData = this.canvasData;
      ratio = Number(ratio);

      if (ratio < 0) {
        ratio = 1 / (1 - ratio);
      } else {
        ratio = 1 + ratio;
      }

      return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
    },

    /**
     * Zoom the canvas to an absolute ratio
     * @param {number} ratio - The target ratio.
     * @param {Object} pivot - The zoom pivot point coordinate.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
      var options = this.options,
          canvasData = this.canvasData;
      var width = canvasData.width,
          height = canvasData.height,
          naturalWidth = canvasData.naturalWidth,
          naturalHeight = canvasData.naturalHeight;
      ratio = Number(ratio);

      if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
        var newWidth = naturalWidth * ratio;
        var newHeight = naturalHeight * ratio;

        if (dispatchEvent(this.element, EVENT_ZOOM, {
          ratio: ratio,
          oldRatio: width / naturalWidth,
          originalEvent: _originalEvent
        }) === false) {
          return this;
        }

        if (_originalEvent) {
          var pointers = this.pointers;
          var offset = getOffset(this.cropper);
          var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
            pageX: _originalEvent.pageX,
            pageY: _originalEvent.pageY
          }; // Zoom from the triggering point of the event

          canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
        } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
          canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
        } else {
          // Zoom from the center of the canvas
          canvasData.left -= (newWidth - width) / 2;
          canvasData.top -= (newHeight - height) / 2;
        }

        canvasData.width = newWidth;
        canvasData.height = newHeight;
        this.renderCanvas(true);
      }

      return this;
    },

    /**
     * Rotate the canvas with a relative degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotate: function rotate(degree) {
      return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
    },

    /**
     * Rotate the canvas to an absolute degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotateTo: function rotateTo(degree) {
      degree = Number(degree);

      if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
        this.imageData.rotate = degree % 360;
        this.renderCanvas(true, true);
      }

      return this;
    },

    /**
     * Scale the image on the x-axis.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @returns {Cropper} this
     */
    scaleX: function scaleX(_scaleX) {
      var scaleY = this.imageData.scaleY;
      return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
    },

    /**
     * Scale the image on the y-axis.
     * @param {number} scaleY - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scaleY: function scaleY(_scaleY) {
      var scaleX = this.imageData.scaleX;
      return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
    },

    /**
     * Scale the image
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scale: function scale(scaleX) {
      var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
      var imageData = this.imageData;
      var transformed = false;
      scaleX = Number(scaleX);
      scaleY = Number(scaleY);

      if (this.ready && !this.disabled && this.options.scalable) {
        if (isNumber(scaleX)) {
          imageData.scaleX = scaleX;
          transformed = true;
        }

        if (isNumber(scaleY)) {
          imageData.scaleY = scaleY;
          transformed = true;
        }

        if (transformed) {
          this.renderCanvas(true, true);
        }
      }

      return this;
    },

    /**
     * Get the cropped area position and size data (base on the original image)
     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
     * @returns {Object} The result cropped data.
     */
    getData: function getData() {
      var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var options = this.options,
          imageData = this.imageData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var data;

      if (this.ready && this.cropped) {
        data = {
          x: cropBoxData.left - canvasData.left,
          y: cropBoxData.top - canvasData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
        var ratio = imageData.width / imageData.naturalWidth;
        forEach(data, function (n, i) {
          data[i] = n / ratio;
        });

        if (rounded) {
          // In case rounding off leads to extra 1px in right or bottom border
          // we should round the top-left corner and the dimension (#343).
          var bottom = Math.round(data.y + data.height);
          var right = Math.round(data.x + data.width);
          data.x = Math.round(data.x);
          data.y = Math.round(data.y);
          data.width = right - data.x;
          data.height = bottom - data.y;
        }
      } else {
        data = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }

      if (options.rotatable) {
        data.rotate = imageData.rotate || 0;
      }

      if (options.scalable) {
        data.scaleX = imageData.scaleX || 1;
        data.scaleY = imageData.scaleY || 1;
      }

      return data;
    },

    /**
     * Set the cropped area position and size with new data
     * @param {Object} data - The new data.
     * @returns {Cropper} this
     */
    setData: function setData(data) {
      var options = this.options,
          imageData = this.imageData,
          canvasData = this.canvasData;
      var cropBoxData = {};

      if (this.ready && !this.disabled && isPlainObject(data)) {
        var transformed = false;

        if (options.rotatable) {
          if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
            imageData.rotate = data.rotate;
            transformed = true;
          }
        }

        if (options.scalable) {
          if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
            imageData.scaleX = data.scaleX;
            transformed = true;
          }

          if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
            imageData.scaleY = data.scaleY;
            transformed = true;
          }
        }

        if (transformed) {
          this.renderCanvas(true, true);
        }

        var ratio = imageData.width / imageData.naturalWidth;

        if (isNumber(data.x)) {
          cropBoxData.left = data.x * ratio + canvasData.left;
        }

        if (isNumber(data.y)) {
          cropBoxData.top = data.y * ratio + canvasData.top;
        }

        if (isNumber(data.width)) {
          cropBoxData.width = data.width * ratio;
        }

        if (isNumber(data.height)) {
          cropBoxData.height = data.height * ratio;
        }

        this.setCropBoxData(cropBoxData);
      }

      return this;
    },

    /**
     * Get the container size data.
     * @returns {Object} The result container data.
     */
    getContainerData: function getContainerData() {
      return this.ready ? assign({}, this.containerData) : {};
    },

    /**
     * Get the image position and size data.
     * @returns {Object} The result image data.
     */
    getImageData: function getImageData() {
      return this.sized ? assign({}, this.imageData) : {};
    },

    /**
     * Get the canvas position and size data.
     * @returns {Object} The result canvas data.
     */
    getCanvasData: function getCanvasData() {
      var canvasData = this.canvasData;
      var data = {};

      if (this.ready) {
        forEach(['left', 'top', 'width', 'height', 'naturalWidth', 'naturalHeight'], function (n) {
          data[n] = canvasData[n];
        });
      }

      return data;
    },

    /**
     * Set the canvas position and size with new data.
     * @param {Object} data - The new canvas data.
     * @returns {Cropper} this
     */
    setCanvasData: function setCanvasData(data) {
      var canvasData = this.canvasData;
      var aspectRatio = canvasData.aspectRatio;

      if (this.ready && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          canvasData.left = data.left;
        }

        if (isNumber(data.top)) {
          canvasData.top = data.top;
        }

        if (isNumber(data.width)) {
          canvasData.width = data.width;
          canvasData.height = data.width / aspectRatio;
        } else if (isNumber(data.height)) {
          canvasData.height = data.height;
          canvasData.width = data.height * aspectRatio;
        }

        this.renderCanvas(true);
      }

      return this;
    },

    /**
     * Get the crop box position and size data.
     * @returns {Object} The result crop box data.
     */
    getCropBoxData: function getCropBoxData() {
      var cropBoxData = this.cropBoxData;
      var data;

      if (this.ready && this.cropped) {
        data = {
          left: cropBoxData.left,
          top: cropBoxData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
      }

      return data || {};
    },

    /**
     * Set the crop box position and size with new data.
     * @param {Object} data - The new crop box data.
     * @returns {Cropper} this
     */
    setCropBoxData: function setCropBoxData(data) {
      var cropBoxData = this.cropBoxData;
      var aspectRatio = this.options.aspectRatio;
      var widthChanged;
      var heightChanged;

      if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          cropBoxData.left = data.left;
        }

        if (isNumber(data.top)) {
          cropBoxData.top = data.top;
        }

        if (isNumber(data.width) && data.width !== cropBoxData.width) {
          widthChanged = true;
          cropBoxData.width = data.width;
        }

        if (isNumber(data.height) && data.height !== cropBoxData.height) {
          heightChanged = true;
          cropBoxData.height = data.height;
        }

        if (aspectRatio) {
          if (widthChanged) {
            cropBoxData.height = cropBoxData.width / aspectRatio;
          } else if (heightChanged) {
            cropBoxData.width = cropBoxData.height * aspectRatio;
          }
        }

        this.renderCropBox();
      }

      return this;
    },

    /**
     * Get a canvas drawn the cropped image.
     * @param {Object} [options={}] - The config options.
     * @returns {HTMLCanvasElement} - The result canvas.
     */
    getCroppedCanvas: function getCroppedCanvas() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.ready || !window.HTMLCanvasElement) {
        return null;
      }

      var canvasData = this.canvasData;
      var source = getSourceCanvas(this.image, this.imageData, canvasData, options); // Returns the source canvas if it is not cropped.

      if (!this.cropped) {
        return source;
      }

      var _this$getData = this.getData(),
          initialX = _this$getData.x,
          initialY = _this$getData.y,
          initialWidth = _this$getData.width,
          initialHeight = _this$getData.height;

      var ratio = source.width / Math.floor(canvasData.naturalWidth);

      if (ratio !== 1) {
        initialX *= ratio;
        initialY *= ratio;
        initialWidth *= ratio;
        initialHeight *= ratio;
      }

      var aspectRatio = initialWidth / initialHeight;
      var maxSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.maxWidth || Infinity,
        height: options.maxHeight || Infinity
      });
      var minSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.minWidth || 0,
        height: options.minHeight || 0
      }, 'cover');

      var _getAdjustedSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.width || (ratio !== 1 ? source.width : initialWidth),
        height: options.height || (ratio !== 1 ? source.height : initialHeight)
      }),
          width = _getAdjustedSizes.width,
          height = _getAdjustedSizes.height;

      width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
      height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = normalizeDecimalNumber(width);
      canvas.height = normalizeDecimalNumber(height);
      context.fillStyle = options.fillColor || 'transparent';
      context.fillRect(0, 0, width, height);
      var _options$imageSmoothi = options.imageSmoothingEnabled,
          imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi,
          imageSmoothingQuality = options.imageSmoothingQuality;
      context.imageSmoothingEnabled = imageSmoothingEnabled;

      if (imageSmoothingQuality) {
        context.imageSmoothingQuality = imageSmoothingQuality;
      } // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage


      var sourceWidth = source.width;
      var sourceHeight = source.height; // Source canvas parameters

      var srcX = initialX;
      var srcY = initialY;
      var srcWidth;
      var srcHeight; // Destination canvas parameters

      var dstX;
      var dstY;
      var dstWidth;
      var dstHeight;

      if (srcX <= -initialWidth || srcX > sourceWidth) {
        srcX = 0;
        srcWidth = 0;
        dstX = 0;
        dstWidth = 0;
      } else if (srcX <= 0) {
        dstX = -srcX;
        srcX = 0;
        srcWidth = Math.min(sourceWidth, initialWidth + srcX);
        dstWidth = srcWidth;
      } else if (srcX <= sourceWidth) {
        dstX = 0;
        srcWidth = Math.min(initialWidth, sourceWidth - srcX);
        dstWidth = srcWidth;
      }

      if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
        srcY = 0;
        srcHeight = 0;
        dstY = 0;
        dstHeight = 0;
      } else if (srcY <= 0) {
        dstY = -srcY;
        srcY = 0;
        srcHeight = Math.min(sourceHeight, initialHeight + srcY);
        dstHeight = srcHeight;
      } else if (srcY <= sourceHeight) {
        dstY = 0;
        srcHeight = Math.min(initialHeight, sourceHeight - srcY);
        dstHeight = srcHeight;
      }

      var params = [srcX, srcY, srcWidth, srcHeight]; // Avoid "IndexSizeError"

      if (dstWidth > 0 && dstHeight > 0) {
        var scale = width / initialWidth;
        params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
      } // All the numerical parameters should be integer for `drawImage`
      // https://github.com/fengyuanchen/cropper/issues/476


      context.drawImage.apply(context, [source].concat(_toConsumableArray(params.map(function (param) {
        return Math.floor(normalizeDecimalNumber(param));
      }))));
      return canvas;
    },

    /**
     * Change the aspect ratio of the crop box.
     * @param {number} aspectRatio - The new aspect ratio.
     * @returns {Cropper} this
     */
    setAspectRatio: function setAspectRatio(aspectRatio) {
      var options = this.options;

      if (!this.disabled && !isUndefined(aspectRatio)) {
        // 0 -> NaN
        options.aspectRatio = Math.max(0, aspectRatio) || NaN;

        if (this.ready) {
          this.initCropBox();

          if (this.cropped) {
            this.renderCropBox();
          }
        }
      }

      return this;
    },

    /**
     * Change the drag mode.
     * @param {string} mode - The new drag mode.
     * @returns {Cropper} this
     */
    setDragMode: function setDragMode(mode) {
      var options = this.options,
          dragBox = this.dragBox,
          face = this.face;

      if (this.ready && !this.disabled) {
        var croppable = mode === DRAG_MODE_CROP;
        var movable = options.movable && mode === DRAG_MODE_MOVE;
        mode = croppable || movable ? mode : DRAG_MODE_NONE;
        options.dragMode = mode;
        setData(dragBox, DATA_ACTION, mode);
        toggleClass(dragBox, CLASS_CROP, croppable);
        toggleClass(dragBox, CLASS_MOVE, movable);

        if (!options.cropBoxMovable) {
          // Sync drag mode to crop box when it is not movable
          setData(face, DATA_ACTION, mode);
          toggleClass(face, CLASS_CROP, croppable);
          toggleClass(face, CLASS_MOVE, movable);
        }
      }

      return this;
    }
  };

  var AnotherCropper = WINDOW.Cropper;

  var Cropper =
  /*#__PURE__*/
  function () {
    /**
     * Create a new Cropper.
     * @param {Element} element - The target element for cropping.
     * @param {Object} [options={}] - The configuration options.
     */
    function Cropper(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Cropper);

      if (!element || !REGEXP_TAG_NAME.test(element.tagName)) {
        throw new Error('The first argument is required and must be an <img> or <canvas> element.');
      }

      this.element = element;
      this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
      this.cropped = false;
      this.disabled = false;
      this.pointers = {};
      this.ready = false;
      this.reloading = false;
      this.replaced = false;
      this.sized = false;
      this.sizing = false;
      this.init();
    }

    _createClass(Cropper, [{
      key: "init",
      value: function init() {
        var element = this.element;
        var tagName = element.tagName.toLowerCase();
        var url;

        if (element[NAMESPACE]) {
          return;
        }

        element[NAMESPACE] = this;

        if (tagName === 'img') {
          this.isImg = true; // e.g.: "img/picture.jpg"

          url = element.getAttribute('src') || '';
          this.originalUrl = url; // Stop when it's a blank image

          if (!url) {
            return;
          } // e.g.: "http://example.com/img/picture.jpg"


          url = element.src;
        } else if (tagName === 'canvas' && window.HTMLCanvasElement) {
          url = element.toDataURL();
        }

        this.load(url);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this = this;

        if (!url) {
          return;
        }

        this.url = url;
        this.imageData = {};
        var element = this.element,
            options = this.options;

        if (!options.rotatable && !options.scalable) {
          options.checkOrientation = false;
        } // Only IE10+ supports Typed Arrays


        if (!options.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        } // Detect the mime type of the image directly if it is a Data URL


        if (REGEXP_DATA_URL.test(url)) {
          // Read ArrayBuffer from Data URL of JPEG images directly for better performance
          if (REGEXP_DATA_URL_JPEG.test(url)) {
            this.read(dataURLToArrayBuffer(url));
          } else {
            // Only a JPEG image may contains Exif Orientation information,
            // the rest types of Data URLs are not necessary to check orientation at all.
            this.clone();
          }

          return;
        } // 1. Detect the mime type of the image by a XMLHttpRequest.
        // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.


        var xhr = new XMLHttpRequest();
        var clone = this.clone.bind(this);
        this.reloading = true;
        this.xhr = xhr; // 1. Cross origin requests are only supported for protocol schemes:
        // http, https, data, chrome, chrome-extension.
        // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
        // in some browsers as IE11 and Safari.

        xhr.onabort = clone;
        xhr.onerror = clone;
        xhr.ontimeout = clone;

        xhr.onprogress = function () {
          // Abort the request directly if it not a JPEG image for better performance
          if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) {
            xhr.abort();
          }
        };

        xhr.onload = function () {
          _this.read(xhr.response);
        };

        xhr.onloadend = function () {
          _this.reloading = false;
          _this.xhr = null;
        }; // Bust cache when there is a "crossOrigin" property to avoid browser cache error


        if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) {
          url = addTimestamp(url);
        }

        xhr.open('GET', url);
        xhr.responseType = 'arraybuffer';
        xhr.withCredentials = element.crossOrigin === 'use-credentials';
        xhr.send();
      }
    }, {
      key: "read",
      value: function read(arrayBuffer) {
        var options = this.options,
            imageData = this.imageData; // Reset the orientation value to its default value 1
        // as some iOS browsers will render image with its orientation

        var orientation = resetAndGetOrientation(arrayBuffer);
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;

        if (orientation > 1) {
          // Generate a new URL which has the default orientation value
          this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);

          var _parseOrientation = parseOrientation(orientation);

          rotate = _parseOrientation.rotate;
          scaleX = _parseOrientation.scaleX;
          scaleY = _parseOrientation.scaleY;
        }

        if (options.rotatable) {
          imageData.rotate = rotate;
        }

        if (options.scalable) {
          imageData.scaleX = scaleX;
          imageData.scaleY = scaleY;
        }

        this.clone();
      }
    }, {
      key: "clone",
      value: function clone() {
        var element = this.element,
            url = this.url;
        var crossOrigin = element.crossOrigin;
        var crossOriginUrl = url;

        if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
          if (!crossOrigin) {
            crossOrigin = 'anonymous';
          } // Bust cache when there is not a "crossOrigin" property (#519)


          crossOriginUrl = addTimestamp(url);
        }

        this.crossOrigin = crossOrigin;
        this.crossOriginUrl = crossOriginUrl;
        var image = document.createElement('img');

        if (crossOrigin) {
          image.crossOrigin = crossOrigin;
        }

        image.src = crossOriginUrl || url;
        image.alt = element.alt || 'The image to crop';
        this.image = image;
        image.onload = this.start.bind(this);
        image.onerror = this.stop.bind(this);
        addClass(image, CLASS_HIDE);
        element.parentNode.insertBefore(image, element.nextSibling);
      }
    }, {
      key: "start",
      value: function start() {
        var _this2 = this;

        var image = this.image;
        image.onload = null;
        image.onerror = null;
        this.sizing = true; // Match all browsers that use WebKit as the layout engine in iOS devices,
        // such as Safari for iOS, Chrome for iOS, and in-app browsers.

        var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);

        var done = function done(naturalWidth, naturalHeight) {
          assign(_this2.imageData, {
            naturalWidth: naturalWidth,
            naturalHeight: naturalHeight,
            aspectRatio: naturalWidth / naturalHeight
          });
          _this2.sizing = false;
          _this2.sized = true;

          _this2.build();
        }; // Most modern browsers (excepts iOS WebKit)


        if (image.naturalWidth && !isIOSWebKit) {
          done(image.naturalWidth, image.naturalHeight);
          return;
        }

        var sizingImage = document.createElement('img');
        var body = document.body || document.documentElement;
        this.sizingImage = sizingImage;

        sizingImage.onload = function () {
          done(sizingImage.width, sizingImage.height);

          if (!isIOSWebKit) {
            body.removeChild(sizingImage);
          }
        };

        sizingImage.src = image.src; // iOS WebKit will convert the image automatically
        // with its orientation once append it into DOM (#279)

        if (!isIOSWebKit) {
          sizingImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
          body.appendChild(sizingImage);
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        var image = this.image;
        image.onload = null;
        image.onerror = null;
        image.parentNode.removeChild(image);
        this.image = null;
      }
    }, {
      key: "build",
      value: function build() {
        if (!this.sized || this.ready) {
          return;
        }

        var element = this.element,
            options = this.options,
            image = this.image; // Create cropper elements

        var container = element.parentNode;
        var template = document.createElement('div');
        template.innerHTML = TEMPLATE;
        var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
        var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
        var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
        var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
        var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
        this.container = container;
        this.cropper = cropper;
        this.canvas = canvas;
        this.dragBox = dragBox;
        this.cropBox = cropBox;
        this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
        this.face = face;
        canvas.appendChild(image); // Hide the original image

        addClass(element, CLASS_HIDDEN); // Inserts the cropper after to the current image

        container.insertBefore(cropper, element.nextSibling); // Show the image if is hidden

        if (!this.isImg) {
          removeClass(image, CLASS_HIDE);
        }

        this.initPreview();
        this.bind();
        options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
        options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
        options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
        addClass(cropBox, CLASS_HIDDEN);

        if (!options.guides) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
        }

        if (!options.center) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
        }

        if (options.background) {
          addClass(cropper, "".concat(NAMESPACE, "-bg"));
        }

        if (!options.highlight) {
          addClass(face, CLASS_INVISIBLE);
        }

        if (options.cropBoxMovable) {
          addClass(face, CLASS_MOVE);
          setData(face, DATA_ACTION, ACTION_ALL);
        }

        if (!options.cropBoxResizable) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
        }

        this.render();
        this.ready = true;
        this.setDragMode(options.dragMode);

        if (options.autoCrop) {
          this.crop();
        }

        this.setData(options.data);

        if (isFunction(options.ready)) {
          addListener(element, EVENT_READY, options.ready, {
            once: true
          });
        }

        dispatchEvent(element, EVENT_READY);
      }
    }, {
      key: "unbuild",
      value: function unbuild() {
        if (!this.ready) {
          return;
        }

        this.ready = false;
        this.unbind();
        this.resetPreview();
        this.cropper.parentNode.removeChild(this.cropper);
        removeClass(this.element, CLASS_HIDDEN);
      }
    }, {
      key: "uncreate",
      value: function uncreate() {
        if (this.ready) {
          this.unbuild();
          this.ready = false;
          this.cropped = false;
        } else if (this.sizing) {
          this.sizingImage.onload = null;
          this.sizing = false;
          this.sized = false;
        } else if (this.reloading) {
          this.xhr.onabort = null;
          this.xhr.abort();
        } else if (this.image) {
          this.stop();
        }
      }
      /**
       * Get the no conflict cropper class.
       * @returns {Cropper} The cropper class.
       */

    }], [{
      key: "noConflict",
      value: function noConflict() {
        window.Cropper = AnotherCropper;
        return Cropper;
      }
      /**
       * Change the default options.
       * @param {Object} options - The new default options.
       */

    }, {
      key: "setDefaults",
      value: function setDefaults(options) {
        assign(DEFAULTS, isPlainObject(options) && options);
      }
    }]);

    return Cropper;
  }();

  assign(Cropper.prototype, render, preview, events, handlers, change, methods);

  return Cropper;

}));


/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(597);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("03ea7902", content, true, {});

/***/ }),

/***/ 558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'galeria',
  methods: {
    adicionarFoto: function adicionarFoto(elem) {
      this.$store.dispatch('uploadImages', elem.target.files[0]);
    },
    removerFoto: function removerFoto(elem) {
      this.$store.dispatch('deleteImages', 'url');
    }
  },
  computed: {
    fotos: function fotos() {
      return this.$store.getters.itemSelecionado.fotos;
    }
  }
});

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cropperjs__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cropperjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cropperjs_dist_cropper_css__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cropperjs_dist_cropper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cropperjs_dist_cropper_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'image-upload',
  components: {
    Cropper: __WEBPACK_IMPORTED_MODULE_0_cropperjs___default.a
  },
  data: function data() {
    return {
      cropper: false,
      cropperOn: false,
      cropPreviewStyle: {
        width: '0',
        height: '0',
        transform: ''
      },
      shelfedImage: '',
      image: ''
    };
  },
  created: function created() {},

  methods: {
    removeImage: function removeImage() {
      this.shelfedImage = '';
    },
    updateImage: function updateImage(value) {
      this.shelfedImage = value;
    },
    shelfImage: function shelfImage(elem) {
      var _this = this;

      var image = {
        elem: elem.target.files[0],
        size: elem.target.files[0].size,
        extension: elem.target.value.substring(elem.target.value.lastIndexOf('.') + 1).toLowerCase()
      };
      if (image.size > 3000000) {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Insira uma image de até 3mb'
        });
        return;
      }
      if (image.extension === 'gif' || image.extension === 'png' || image.extension === 'bmp' || image.extension === 'jpeg' || image.extension === 'jpg') {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this.shelfedImage = e.target.result;
        };
        reader.readAsDataURL(image.elem);
        this.image = image.elem;
      } else {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Insira uma imagem com a extensão .png'
        });
      }
    },
    unshelfImage: function unshelfImage() {
      this.shelfedImage = '';
    },
    crop: function crop() {
      this.$store.commit('updateImgUploadCrop', this.cropper.getData());
      this.cropper.destroy();
      this.cropper = false;
      this.cropperOn = false;
      this.$store.dispatch('uploadItemImage', this.image);
      this.shelfedImage = '';
    },
    close: function close() {
      if (this.cropper) {
        this.cropper.destroy();
      }
      this.shelfedImage = '';
      this.$store.commit('updateImgUploadImage', '');
      this.imageUploadModal = false;
    }
  },
  computed: {
    imageUploadModal: {
      get: function get() {
        return this.$store.getters.imgUploadVisible;
      },
      set: function set() {
        this.dataTags = '';
        this.$store.commit('toggleImgUploadModal', false);
      }
    },
    imgUploadImage: {
      get: function get() {
        return this.$store.getters.imgUploadImage;
      }
    },
    imgUploadIndex: {
      get: function get() {
        return this.$store.getters.imgUploadIndex;
      }
    }
  },
  watch: {
    shelfedImage: function shelfedImage() {
      var _this2 = this;

      if (this.shelfedImage) {
        this.cropperOn = true;
        var vueObj = this;
        this.$nextTick(function () {
          var cropper = new __WEBPACK_IMPORTED_MODULE_0_cropperjs___default.a(document.getElementById('imgToCrop'), {
            viewMode: 3,
            aspectRatio: 1,
            movable: false,
            zoomable: false,
            handleWidth: 16,
            handleOffset: -10,
            crop: function crop(event) {
              var scale = 200 / event.detail.width;
              vueObj.cropPreviewStyle.width = event.target.width * scale + 'px';
              vueObj.cropPreviewStyle.height = event.target.height * scale + 'px';
              vueObj.cropPreviewStyle.transform = 'translateX(-' + event.detail.x * scale + 'px) translateY(-' + event.detail.y * scale + 'px)';
            }
          });
          _this2.cropper = cropper;
        });
      } else {
        if (this.cropper) {
          this.cropper.destroy();
          this.cropper = false;
        }
      }
    }
  }
});

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SelectionBtn__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SelectionBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_SelectionBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Galeria__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Galeria___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Galeria__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cropperjs__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_cropperjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cropperjs_dist_cropper_css__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cropperjs_dist_cropper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_cropperjs_dist_cropper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_timers__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imageUpload__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imageUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__imageUpload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'item-detalhes',
  components: {
    SelectionBtn: __WEBPACK_IMPORTED_MODULE_0__components_SelectionBtn___default.a,
    Galeria: __WEBPACK_IMPORTED_MODULE_1__Galeria___default.a,
    Cropper: __WEBPACK_IMPORTED_MODULE_3_cropperjs___default.a,
    ImageUpload: __WEBPACK_IMPORTED_MODULE_6__imageUpload___default.a
  },
  data: function data() {
    return {
      dataTags: '',
      setLocale: '',
      ativo: false,
      cropper: false,
      cropperOn: false,
      cropPreviewStyle: {
        width: '0',
        height: '0',
        transform: ''
      },
      termsOfUseDialog: false,
      rules: {
        categories: [function (v) {
          return !!v > 0 || 'Selecione uma categoria';
        }
        // (v) => this.categories.filter(elem => elem === v).length === 1 || 'Categoria inválida'
        ],
        name: [function (v) {
          return v.length > 0 || 'Insira um nome para o item';
        }],
        description: [function (v) {
          return v.length > 0 || 'Insira uma descrição';
        }, function (v) {
          return v.length < 251 || 'Descrição muito longa';
        }],
        tags: [function (v) {
          return v.length > 100 || 'Máximo de 100 caracteres por tag';
        }],
        singlePrice: [function (v) {
          return v.length > 0 || 'Insira um valor';
        }],
        multiPrice: [function (v) {
          return !!v > 0 || 'Insira um valor';
        }],
        multiDescription: [function (v) {
          return v.length > 0 || 'Insira uma descrição';
        }]
      }
    };
  },
  created: function created() {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
      _this.setLocale = _this.item.categories;
    }, 1500);
  },

  methods: {
    priceValidation: function priceValidation() {
      var _this2 = this;

      var validation = true;
      if (this.$store.getters.selectedItemPriceVariations) {
        if (this.$refs.pricetableList.classList.contains('price-table-error')) {
          this.$refs.pricetableList.classList.remove('price-table-error');
        }
        var priceTable = this.$store.getters.selectedItemPriceTable;
        priceTable.forEach(function (element) {
          if (element.priceRef !== '' && element.priceRef !== null) {
            if (element.priceRef <= element.price) {
              validation = false;
              _this2.$refs.pricetableList.classList.add('price-table-error');
            }
          }
        });
        if (!validation) {
          this.$store.commit('toastr', {
            color: 'info',
            texto: 'Valor referência tem de ser maior que valor cadastrado'
          });
        }
      }
      return validation;
    },
    updateItem: function updateItem() {
      if (this.priceValidation()) {
        if (this.validityStartPicker === null && this.validityEndPicker === null) {
          if (this.$refs.itemForm.validate()) {
            this.$store.dispatch('updateItem');
          } else {
            this.$store.commit('toastr', {
              color: 'info',
              texto: 'Verifique os campos em vermelho'
            });
          }
        } else {
          if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.item.validityStart).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.item.validityEnd)) <= 0) {
            if (this.$refs.itemForm.validate()) {
              this.$store.dispatch('updateItem');
            } else {
              this.$store.commit('toastr', {
                color: 'info',
                texto: 'Verifique os campos em vermelho'
              });
            }
          } else {
            this.$store.commit('toastr', {
              color: 'info',
              texto: 'O campo vigência final não pode ser menor que a inicial'
            });
            return;
          }
        }
      }
    },
    saveTermsOfUse: function saveTermsOfUse() {
      this.$store.commit('updateTermsOfUseContent', this.editorContent);
      this.termsOfUseDialog = false;
    },
    cancelTermsOfUse: function cancelTermsOfUse() {
      this.editorContent = '';
    },
    toggleActive: function toggleActive() {
      this.$store.commit('toggleActive');
    },
    updateName: function updateName(value) {
      this.$store.commit('updateName', value);
    },
    updateDescription: function updateDescription(value) {
      this.$store.commit('updateDescription', value);
    },
    updateCode: function updateCode(value) {
      this.$store.commit('updateCode', value);
    },
    updateRealizationTime: function updateRealizationTime(value) {
      this.$store.commit('updateRealizationTime', value);
    },
    addTag: function addTag() {
      if (this.dataTags.length > 100) {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'Máximo de 100 caracteres por tag'
        });
        return;
      }
      this.$store.commit('addTag', this.dataTags);
      this.dataTags = '';
    },
    removeTag: function removeTag(tag) {
      this.$store.commit('removeTag', tag);
    },
    updateValidityStart: function updateValidityStart(value) {
      if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(value).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(), 'days') < 0) {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'A data de inicio não pode estar no passado'
        });
        return;
      }
      if (this.validityEndPicker !== null) {
        if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(value).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.item.validityEnd)) <= 0) {
          this.$store.commit('updateValidityStart', value);
        } else {
          this.$store.commit('toastr', {
            color: 'info',
            texto: 'A data de inicio não pode ser maior que a final'
          });
        }
      } else {
        this.$store.commit('updateValidityStart', value);
      }
    },
    updateValidityEnd: function updateValidityEnd(value) {
      if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(value).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(), 'days') < 0) {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'A data de fim não pode estar no passado'
        });
        return;
      }
      if (this.validityStartPicker !== null) {
        if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(value).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.item.validityStart)) >= 0) {
          this.$store.commit('updateValidityEnd', value);
        } else {
          this.$store.commit('toastr', {
            color: 'info',
            texto: 'A data final não pode ser menor que o inicio'
          });
        }
      } else {
        this.$store.commit('updateValidityEnd', value);
      }
    },
    updateFamily: function updateFamily(value) {
      this.$store.commit('updateFamily', value);
    },
    updateSeq: function updateSeq(value) {
      this.$store.commit('updateSeq', value);
    },
    updateCategories: function updateCategories(value) {
      this.$store.commit('updateCategories', value);
    },
    updatePayments: function updatePayments(value) {
      this.$store.commit('updatePayments', value);
    },
    togglePriceVariations: function togglePriceVariations(value) {
      this.$store.commit('togglePriceVariations');
    },
    formatPrice: function formatPrice(value) {
      value = parseFloat(String(value).replace(',', '.'));
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    updateSinglePrice: function updateSinglePrice(elem) {
      this.$store.commit('updateSinglePrice', elem);
    },
    updateMultiPrice: function updateMultiPrice(elem, index) {
      if (elem !== '') {
        this.$store.commit('updateMultiPrice', {
          index: index,
          value: elem
        });
      }
    },
    updatePriceText: function updatePriceText(elem, index) {
      if (elem !== '') {
        this.$store.commit('updatePriceText', {
          index: index,
          value: elem
        });
      }
    },
    updateMultiPriceRef: function updateMultiPriceRef(elem, index) {
      if (elem !== '') {
        this.$store.commit('updateMultiPriceRef', {
          index: index,
          value: elem
        });
      }
    },
    deleteMultiPrice: function deleteMultiPrice(index) {
      this.$store.commit('deleteMultiPrice', index);
    },
    addMultiPrice: function addMultiPrice() {
      this.$store.commit('addMultiPrice');
    },
    close: function close() {
      this.$store.commit('unshelfImage');
      this.$store.commit('closeItem');
    },
    removeImage: function removeImage() {
      this.$store.commit('updateImage', '');
    },
    updateImage: function updateImage(value) {
      this.$store.commit('updateImage', value);
    },
    shelfImage: function shelfImage(elem) {
      var image = {
        elem: elem.target.files[0],
        size: elem.target.files[0].size,
        extension: elem.target.value.substring(elem.target.value.lastIndexOf('.') + 1).toLowerCase()
      };
      if (image.size > 3000000) {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Insira uma image de até 3mb'
        });
        return;
      }
      if (image.extension === 'gif' || image.extension === 'png' || image.extension === 'bmp' || image.extension === 'jpeg' || image.extension === 'jpg') {
        this.$store.dispatch('shelfImage', image.elem);
      } else {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Insira uma imagem com a extensão .png'
        });
      }
    },
    unshelfImage: function unshelfImage() {
      this.$store.commit('unshelfImage');
    },
    toggleNeedSchedule: function toggleNeedSchedule() {
      this.$store.commit('toggleNeedSchedule');
    },
    toggleCustomTime: function toggleCustomTime() {
      this.$store.commit('toggleCustomTime');
    },
    updateWeekdayStart: function updateWeekdayStart(value) {
      this.$store.commit('updateWeekdayStart', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateWeekdayEnd: function updateWeekdayEnd(value) {
      this.$store.commit('updateWeekdayEnd', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateWeekdayInterval: function updateWeekdayInterval(value) {
      this.$store.commit('updateWeekdayInterval', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateWeekdayCapacity: function updateWeekdayCapacity(value) {
      this.$store.commit('updateWeekdayCapacity', value);
    },
    updateSundayStart: function updateSundayStart(value) {
      this.$store.commit('updateSundayStart', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateSundayEnd: function updateSundayEnd(value) {
      this.$store.commit('updateSundayEnd', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateSundayInterval: function updateSundayInterval(value) {
      this.$store.commit('updateSundayInterval', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateSundayCapacity: function updateSundayCapacity(value) {
      this.$store.commit('updateSundayCapacity', value);
    },
    updateMondayStart: function updateMondayStart(value) {
      this.$store.commit('updateMondayStart', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateMondayEnd: function updateMondayEnd(value) {
      this.$store.commit('updateMondayEnd', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateMondayInterval: function updateMondayInterval(value) {
      this.$store.commit('updateMondayInterval', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateMondayCapacity: function updateMondayCapacity(value) {
      this.$store.commit('updateMondayCapacity', value);
    },
    updateTuesdayStart: function updateTuesdayStart(value) {
      this.$store.commit('updateTuesdayStart', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateTuesdayEnd: function updateTuesdayEnd(value) {
      this.$store.commit('updateTuesdayEnd', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateTuesdayInterval: function updateTuesdayInterval(value) {
      this.$store.commit('updateTuesdayInterval', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateTuesdayCapacity: function updateTuesdayCapacity(value) {
      this.$store.commit('updateTuesdayCapacity', value);
    },
    updateWednesdayStart: function updateWednesdayStart(value) {
      this.$store.commit('updateWednesdayStart', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateWednesdayEnd: function updateWednesdayEnd(value) {
      this.$store.commit('updateWednesdayEnd', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateWednesdayInterval: function updateWednesdayInterval(value) {
      this.$store.commit('updateWednesdayInterval', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateWednesdayCapacity: function updateWednesdayCapacity(value) {
      this.$store.commit('updateWednesdayCapacity', value);
    },
    updateThursdayStart: function updateThursdayStart(value) {
      this.$store.commit('updateThursdayStart', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateThursdayEnd: function updateThursdayEnd(value) {
      this.$store.commit('updateThursdayEnd', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateThursdayInterval: function updateThursdayInterval(value) {
      this.$store.commit('updateThursdayInterval', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateThursdayCapacity: function updateThursdayCapacity(value) {
      this.$store.commit('updateThursdayCapacity', value);
    },
    updateFridayStart: function updateFridayStart(value) {
      this.$store.commit('updateFridayStart', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateFridayEnd: function updateFridayEnd(value) {
      this.$store.commit('updateFridayEnd', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateFridayInterval: function updateFridayInterval(value) {
      this.$store.commit('updateFridayInterval', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateFridayCapacity: function updateFridayCapacity(value) {
      this.$store.commit('updateFridayCapacity', value);
    },
    updateSaturdayStart: function updateSaturdayStart(value) {
      this.$store.commit('updateSaturdayStart', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateSaturdayEnd: function updateSaturdayEnd(value) {
      this.$store.commit('updateSaturdayEnd', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateSaturdayInterval: function updateSaturdayInterval(value) {
      this.$store.commit('updateSaturdayInterval', value.length === 4 ? value.substring(0, 2) + ':' + value.substring(2) : '');
    },
    updateSaturdayCapacity: function updateSaturdayCapacity(value) {
      this.$store.commit('updateSaturdayCapacity', value);
    },
    crop: function crop() {
      this.$store.commit('updateImageCrop', this.cropper.getData());
      this.cropper.destroy();
      this.cropper = false;
      this.cropperOn = false;
    },
    uploadImage: function uploadImage(index, img) {
      this.$store.commit('updateImgUploadIndex', index);
      this.$store.commit('updateImgUploadImage', img);
      this.$store.commit('toggleImgUploadModal', true);
    }
  },
  computed: {
    termoDeUso: {
      get: function get() {
        return '<p>troioioioi</p>';
      },
      set: function set(value) {
        // console.log('valor mudado', value)
      }
    },
    loadingItemAction: function loadingItemAction() {
      return this.$store.getters.loadingItemAction;
    },
    termsOfUseContent: function termsOfUseContent() {},
    validityEndPicker: function validityEndPicker() {
      return this.item.validityEnd === null ? null : __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.item.validityEnd).format('YYYY-MM-DD');
    },
    validityStartPicker: function validityStartPicker() {
      return this.item.validityStart === null ? null : __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.item.validityStart).format('YYYY-MM-DD') || null;
    },
    validityEndLabel: function validityEndLabel() {
      return this.item.validityEnd === null ? null : __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.item.validityEnd).format('DD-MM-YYYY');
    },
    validityStartLabel: function validityStartLabel() {
      return this.item.validityStart === null ? null : __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.item.validityStart).format('DD-MM-YYYY') || null;
    },
    item: function item() {
      return this.$store.getters.selectedItem;
    },

    categories: {
      get: function get() {
        this.setLocale = this.item.categories;
        return this.$store.getters.categories;
      },
      set: function set() {
        this.$store.commit('updateCategories', this.item.categories);
      }
    },
    payments: function payments() {
      return this.$store.getters.payments;
    },
    families: function families() {
      return this.$store.getters.families;
    },
    dataInicio: function dataInicio() {
      return this.formatar(this.item.validityStart);
    },
    dataFim: function dataFim() {
      return this.formatar(this.item.validityEnd);
    },
    variacao: function variacao() {
      return this.item.priceVariations;
    },

    itemDetalhesModal: {
      get: function get() {
        return this.$store.getters.itemVisible;
      },
      set: function set() {
        this.dataTags = '';
        this.$store.commit('toggleItemModal', false);
      }
    },
    isImg: function isImg() {
      return this.$store.getters.isImg;
    },
    shelfedImage: function shelfedImage() {
      return this.$store.getters.shelfedImage;
    },
    needSchedule: function needSchedule() {
      return this.$store.getters.selectedItem.needSchedule;
    },
    customTime: function customTime() {
      return this.$store.getters.selectedItem.customTime;
    }
  },
  watch: {
    shelfedImage: function shelfedImage() {
      var _this3 = this;

      if (this.shelfedImage) {
        this.cropperOn = true;
        var vueObj = this;
        this.$nextTick(function () {
          var cropper = new __WEBPACK_IMPORTED_MODULE_3_cropperjs___default.a(document.getElementById('imgToCrop'), {
            viewMode: 3,
            aspectRatio: 1,
            movable: false,
            zoomable: false,
            handleWidth: 16,
            handleOffset: -10,
            crop: function crop(event) {
              var scale = 200 / event.detail.width;
              vueObj.cropPreviewStyle.width = event.target.width * scale + 'px';
              vueObj.cropPreviewStyle.height = event.target.height * scale + 'px';
              vueObj.cropPreviewStyle.transform = 'translateX(-' + event.detail.x * scale + 'px) translateY(-' + event.detail.y * scale + 'px)';
            }
          });
          _this3.cropper = cropper;
        });
      } else {
        if (this.cropper) {
          this.cropper.destroy();
          this.cropper = false;
        }
      }
    }
  }
});

/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sharedComponents_item_card__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sharedComponents_item_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sharedComponents_item_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__itemDetalhes__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__itemDetalhes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__itemDetalhes__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Relacao',
  components: {
    ItemCard: __WEBPACK_IMPORTED_MODULE_0__sharedComponents_item_card___default.a,
    ItemDetalhes: __WEBPACK_IMPORTED_MODULE_1__itemDetalhes___default.a
  },
  data: function data() {
    return {
      searchItem: '',
      active: 2
    };
  },

  computed: {
    filteredItens: function filteredItens() {
      var _this = this;

      if (this.searchItem === '') {
        return this.registeredItems.filter(function (elem) {
          return _this.active === 2 || elem.active === (_this.active === 1);
        });
      } else {
        return this.registeredItems.filter(function (elem) {
          var exp = new RegExp(_this.searchItem.trim(), 'i');
          var searchItem = elem.description + elem.name + elem.tags.join();
          if (elem.priceVariations) {
            searchItem = searchItem + elem.priceTable.map(function (elemRow) {
              return elemRow.price + ' ' + elemRow.priceRef + ' ' + elemRow.description;
            }).join();
          } else {
            searchItem = searchItem + elem.price;
          }
          return exp.test(searchItem) && (_this.active === 2 || elem.active === (_this.active === 1));
        });
      }
    },
    registeredItems: function registeredItems() {
      return this.$store.getters.registeredItems;
    }
  },
  methods: {
    itemEscolha: function itemEscolha(item) {
      this.$store.dispatch('selectItem', item);
    },
    filterActive: function filterActive(type) {
      this.active = type;
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('getItems');
    this.$store.dispatch('loadCategories');
    this.$store.dispatch('loadPayments');
  }
});

/***/ }),

/***/ 574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SelectionBtn__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SelectionBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_SelectionBtn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'item-actions',
  props: ['value'],
  data: function data() {
    return {
      exclude: false
    };
  },

  components: {
    'selection-btn': __WEBPACK_IMPORTED_MODULE_0__components_SelectionBtn___default.a
  },
  methods: {
    dialogExclude: function dialogExclude() {
      this.exclude = true;
    },
    excludeItem: function excludeItem() {
      // http://localhost:58515/api/v1/Itens/Remove?id=
      this.exclude = false;
      this.$store.dispatch('deleteItem', this.value.id);
    },
    newSchedule: function newSchedule() {
      this.$store.dispatch('newScheduleSelectedItem', this.value);
    },
    itemEscolha: function itemEscolha(item) {
      this.$store.dispatch('selectItem', item);
    },
    activateItem: function activateItem(value) {
      if (confirm('Tem certeza que deseja ' + (value.active ? 'inativar' : 'ativar') + ' o item?')) {
        this.$store.dispatch('changeActivation', value);
      }
    }
  }
});

/***/ }),

/***/ 575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'item-media',
  props: ['value'],
  computed: {
    image: function image() {
      return this.value.images === null || this.value.images.length === 0 ? '/static/img/image_placeholder.jpg' : this.value.images[0];
    }
  }
});

/***/ }),

/***/ 576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'item-title',
  props: ['value'],
  filters: {
    currency: function currency(value) {
      var newValue = 0;
      if (typeof value !== 'number') {
        newValue = parseFloat(value.replace('.', '').replace(',', '.'));
      } else if (typeof value === 'number') {
        newValue = value;
      } else {
        return '';
      }
      return newValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
  }
});

/***/ }),

/***/ 577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Media__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Media__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Title__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Actions__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Actions__);
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'item-card',
  props: ['value'],
  components: {
    'item-media': __WEBPACK_IMPORTED_MODULE_0__Media___default.a,
    'item-title': __WEBPACK_IMPORTED_MODULE_1__Title___default.a,
    'item-actions': __WEBPACK_IMPORTED_MODULE_2__Actions___default.a
  }
});

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, "/*!\n * Cropper.js v1.5.4\n * https://fengyuanchen.github.io/cropperjs\n *\n * Copyright 2015-present Chen Fengyuan\n * Released under the MIT license\n *\n * Date: 2019-08-03T08:38:38.177Z\n */.cropper-container{direction:ltr;font-size:0;line-height:0;position:relative;-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.cropper-container img{display:block;height:100%;image-orientation:0deg;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;width:100%}.cropper-canvas,.cropper-crop-box,.cropper-drag-box,.cropper-modal,.cropper-wrap-box{bottom:0;left:0;position:absolute;right:0;top:0}.cropper-canvas,.cropper-wrap-box{overflow:hidden}.cropper-drag-box{background-color:#fff;opacity:0}.cropper-modal{background-color:#000;opacity:.5}.cropper-view-box{display:block;height:100%;outline:1px solid #39f;outline-color:rgba(51,153,255,.75);overflow:hidden;width:100%}.cropper-dashed{border:0 dashed #eee;display:block;opacity:.5;position:absolute}.cropper-dashed.dashed-h{border-bottom-width:1px;border-top-width:1px;height:33.33333%;left:0;top:33.33333%;width:100%}.cropper-dashed.dashed-v{border-left-width:1px;border-right-width:1px;height:100%;left:33.33333%;top:0;width:33.33333%}.cropper-center{display:block;height:0;left:50%;opacity:.75;position:absolute;top:50%;width:0}.cropper-center:after,.cropper-center:before{background-color:#eee;content:\" \";display:block;position:absolute}.cropper-center:before{height:1px;left:-3px;top:0;width:7px}.cropper-center:after{height:7px;left:0;top:-3px;width:1px}.cropper-face,.cropper-line,.cropper-point{display:block;height:100%;opacity:.1;position:absolute;width:100%}.cropper-face{background-color:#fff;left:0;top:0}.cropper-line{background-color:#39f}.cropper-line.line-e{cursor:ew-resize;right:-3px;top:0;width:5px}.cropper-line.line-n{cursor:ns-resize;height:5px;left:0;top:-3px}.cropper-line.line-w{cursor:ew-resize;left:-3px;top:0;width:5px}.cropper-line.line-s{bottom:-3px;cursor:ns-resize;height:5px;left:0}.cropper-point{background-color:#39f;height:5px;opacity:.75;width:5px}.cropper-point.point-e{cursor:ew-resize;margin-top:-3px;right:-3px;top:50%}.cropper-point.point-n{cursor:ns-resize;left:50%;margin-left:-3px;top:-3px}.cropper-point.point-w{cursor:ew-resize;left:-3px;margin-top:-3px;top:50%}.cropper-point.point-s{bottom:-3px;cursor:s-resize;left:50%;margin-left:-3px}.cropper-point.point-ne{cursor:nesw-resize;right:-3px;top:-3px}.cropper-point.point-nw{cursor:nwse-resize;left:-3px;top:-3px}.cropper-point.point-sw{bottom:-3px;cursor:nesw-resize;left:-3px}.cropper-point.point-se{bottom:-3px;cursor:nwse-resize;height:20px;opacity:1;right:-3px;width:20px}@media (min-width:768px){.cropper-point.point-se{height:15px;width:15px}}@media (min-width:992px){.cropper-point.point-se{height:10px;width:10px}}@media (min-width:1200px){.cropper-point.point-se{height:5px;opacity:.75;width:5px}}.cropper-point.point-se:before{background-color:#39f;bottom:-50%;content:\" \";display:block;height:200%;opacity:0;position:absolute;right:-50%;width:200%}.cropper-invisible{opacity:0}.cropper-bg{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC\")}.cropper-hide{display:block;height:0;position:absolute;width:0}.cropper-hidden{display:none!important}.cropper-move{cursor:move}.cropper-crop{cursor:crosshair}.cropper-disabled .cropper-drag-box,.cropper-disabled .cropper-face,.cropper-disabled .cropper-line,.cropper-disabled .cropper-point{cursor:not-allowed}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/node_modules/cropperjs/dist/cropper.css"],"names":[],"mappings":"AAAA;;;;;;;;GAQG,AAEH,mBACE,cAAe,AACf,YAAa,AACb,cAAe,AACf,kBAAmB,AACnB,sBAAuB,AACvB,kBAAmB,AACnB,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,gBAAkB,CACnB,AAED,uBACE,cAAe,AACf,YAAa,AACb,uBAAwB,AACxB,0BAA4B,AAC5B,yBAA2B,AAC3B,uBAAyB,AACzB,sBAAwB,AACxB,UAAY,CACb,AAED,qFAKE,SAAU,AACV,OAAQ,AACR,kBAAmB,AACnB,QAAS,AACT,KAAO,CACR,AAED,kCAEE,eAAiB,CAClB,AAED,kBACE,sBAAuB,AACvB,SAAW,CACZ,AAED,eACE,sBAAuB,AACvB,UAAa,CACd,AAED,kBACE,cAAe,AACf,YAAa,AACb,uBAAwB,AACxB,mCAAwC,AACxC,gBAAiB,AACjB,UAAY,CACb,AAED,gBACE,qBAAsB,AACtB,cAAe,AACf,WAAa,AACb,iBAAmB,CACpB,AAED,yBACE,wBAAyB,AACzB,qBAAsB,AACtB,iBAAuB,AACvB,OAAQ,AACR,cAAoB,AACpB,UAAY,CACb,AAED,yBACE,sBAAuB,AACvB,uBAAwB,AACxB,YAAa,AACb,eAAqB,AACrB,MAAO,AACP,eAAsB,CACvB,AAED,gBACE,cAAe,AACf,SAAU,AACV,SAAU,AACV,YAAc,AACd,kBAAmB,AACnB,QAAS,AACT,OAAS,CACV,AAED,6CAEE,sBAAuB,AACvB,YAAa,AACb,cAAe,AACf,iBAAmB,CACpB,AAED,uBACE,WAAY,AACZ,UAAW,AACX,MAAO,AACP,SAAW,CACZ,AAED,sBACE,WAAY,AACZ,OAAQ,AACR,SAAU,AACV,SAAW,CACZ,AAED,2CAGE,cAAe,AACf,YAAa,AACb,WAAa,AACb,kBAAmB,AACnB,UAAY,CACb,AAED,cACE,sBAAuB,AACvB,OAAQ,AACR,KAAO,CACR,AAED,cACE,qBAAuB,CACxB,AAED,qBACE,iBAAkB,AAClB,WAAY,AACZ,MAAO,AACP,SAAW,CACZ,AAED,qBACE,iBAAkB,AAClB,WAAY,AACZ,OAAQ,AACR,QAAU,CACX,AAED,qBACE,iBAAkB,AAClB,UAAW,AACX,MAAO,AACP,SAAW,CACZ,AAED,qBACE,YAAa,AACb,iBAAkB,AAClB,WAAY,AACZ,MAAQ,CACT,AAED,eACE,sBAAuB,AACvB,WAAY,AACZ,YAAc,AACd,SAAW,CACZ,AAED,uBACE,iBAAkB,AAClB,gBAAiB,AACjB,WAAY,AACZ,OAAS,CACV,AAED,uBACE,iBAAkB,AAClB,SAAU,AACV,iBAAkB,AAClB,QAAU,CACX,AAED,uBACE,iBAAkB,AAClB,UAAW,AACX,gBAAiB,AACjB,OAAS,CACV,AAED,uBACE,YAAa,AACb,gBAAiB,AACjB,SAAU,AACV,gBAAkB,CACnB,AAED,wBACE,mBAAoB,AACpB,WAAY,AACZ,QAAU,CACX,AAED,wBACE,mBAAoB,AACpB,UAAW,AACX,QAAU,CACX,AAED,wBACE,YAAa,AACb,mBAAoB,AACpB,SAAW,CACZ,AAED,wBACE,YAAa,AACb,mBAAoB,AACpB,YAAa,AACb,UAAW,AACX,WAAY,AACZ,UAAY,CACb,AAED,yBACE,wBACE,YAAa,AACb,UAAY,CACb,CACF,AAED,yBACE,wBACE,YAAa,AACb,UAAY,CACb,CACF,AAED,0BACE,wBACE,WAAY,AACZ,YAAc,AACd,SAAW,CACZ,CACF,AAED,+BACE,sBAAuB,AACvB,YAAa,AACb,YAAa,AACb,cAAe,AACf,YAAa,AACb,UAAW,AACX,kBAAmB,AACnB,WAAY,AACZ,UAAY,CACb,AAED,mBACE,SAAW,CACZ,AAED,YACE,8QAAgR,CACjR,AAED,cACE,cAAe,AACf,SAAU,AACV,kBAAmB,AACnB,OAAS,CACV,AAED,gBACE,sBAAyB,CAC1B,AAED,cACE,WAAa,CACd,AAED,cACE,gBAAkB,CACnB,AAED,qIAIE,kBAAoB,CACrB","file":"cropper.css","sourcesContent":["/*!\n * Cropper.js v1.5.4\n * https://fengyuanchen.github.io/cropperjs\n *\n * Copyright 2015-present Chen Fengyuan\n * Released under the MIT license\n *\n * Date: 2019-08-03T08:38:38.177Z\n */\n\n.cropper-container {\n  direction: ltr;\n  font-size: 0;\n  line-height: 0;\n  position: relative;\n  -ms-touch-action: none;\n  touch-action: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.cropper-container img {\n  display: block;\n  height: 100%;\n  image-orientation: 0deg;\n  max-height: none !important;\n  max-width: none !important;\n  min-height: 0 !important;\n  min-width: 0 !important;\n  width: 100%;\n}\n\n.cropper-wrap-box,\n.cropper-canvas,\n.cropper-drag-box,\n.cropper-crop-box,\n.cropper-modal {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.cropper-wrap-box,\n.cropper-canvas {\n  overflow: hidden;\n}\n\n.cropper-drag-box {\n  background-color: #fff;\n  opacity: 0;\n}\n\n.cropper-modal {\n  background-color: #000;\n  opacity: 0.5;\n}\n\n.cropper-view-box {\n  display: block;\n  height: 100%;\n  outline: 1px solid #39f;\n  outline-color: rgba(51, 153, 255, 0.75);\n  overflow: hidden;\n  width: 100%;\n}\n\n.cropper-dashed {\n  border: 0 dashed #eee;\n  display: block;\n  opacity: 0.5;\n  position: absolute;\n}\n\n.cropper-dashed.dashed-h {\n  border-bottom-width: 1px;\n  border-top-width: 1px;\n  height: calc(100% / 3);\n  left: 0;\n  top: calc(100% / 3);\n  width: 100%;\n}\n\n.cropper-dashed.dashed-v {\n  border-left-width: 1px;\n  border-right-width: 1px;\n  height: 100%;\n  left: calc(100% / 3);\n  top: 0;\n  width: calc(100% / 3);\n}\n\n.cropper-center {\n  display: block;\n  height: 0;\n  left: 50%;\n  opacity: 0.75;\n  position: absolute;\n  top: 50%;\n  width: 0;\n}\n\n.cropper-center::before,\n.cropper-center::after {\n  background-color: #eee;\n  content: ' ';\n  display: block;\n  position: absolute;\n}\n\n.cropper-center::before {\n  height: 1px;\n  left: -3px;\n  top: 0;\n  width: 7px;\n}\n\n.cropper-center::after {\n  height: 7px;\n  left: 0;\n  top: -3px;\n  width: 1px;\n}\n\n.cropper-face,\n.cropper-line,\n.cropper-point {\n  display: block;\n  height: 100%;\n  opacity: 0.1;\n  position: absolute;\n  width: 100%;\n}\n\n.cropper-face {\n  background-color: #fff;\n  left: 0;\n  top: 0;\n}\n\n.cropper-line {\n  background-color: #39f;\n}\n\n.cropper-line.line-e {\n  cursor: ew-resize;\n  right: -3px;\n  top: 0;\n  width: 5px;\n}\n\n.cropper-line.line-n {\n  cursor: ns-resize;\n  height: 5px;\n  left: 0;\n  top: -3px;\n}\n\n.cropper-line.line-w {\n  cursor: ew-resize;\n  left: -3px;\n  top: 0;\n  width: 5px;\n}\n\n.cropper-line.line-s {\n  bottom: -3px;\n  cursor: ns-resize;\n  height: 5px;\n  left: 0;\n}\n\n.cropper-point {\n  background-color: #39f;\n  height: 5px;\n  opacity: 0.75;\n  width: 5px;\n}\n\n.cropper-point.point-e {\n  cursor: ew-resize;\n  margin-top: -3px;\n  right: -3px;\n  top: 50%;\n}\n\n.cropper-point.point-n {\n  cursor: ns-resize;\n  left: 50%;\n  margin-left: -3px;\n  top: -3px;\n}\n\n.cropper-point.point-w {\n  cursor: ew-resize;\n  left: -3px;\n  margin-top: -3px;\n  top: 50%;\n}\n\n.cropper-point.point-s {\n  bottom: -3px;\n  cursor: s-resize;\n  left: 50%;\n  margin-left: -3px;\n}\n\n.cropper-point.point-ne {\n  cursor: nesw-resize;\n  right: -3px;\n  top: -3px;\n}\n\n.cropper-point.point-nw {\n  cursor: nwse-resize;\n  left: -3px;\n  top: -3px;\n}\n\n.cropper-point.point-sw {\n  bottom: -3px;\n  cursor: nesw-resize;\n  left: -3px;\n}\n\n.cropper-point.point-se {\n  bottom: -3px;\n  cursor: nwse-resize;\n  height: 20px;\n  opacity: 1;\n  right: -3px;\n  width: 20px;\n}\n\n@media (min-width: 768px) {\n  .cropper-point.point-se {\n    height: 15px;\n    width: 15px;\n  }\n}\n\n@media (min-width: 992px) {\n  .cropper-point.point-se {\n    height: 10px;\n    width: 10px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .cropper-point.point-se {\n    height: 5px;\n    opacity: 0.75;\n    width: 5px;\n  }\n}\n\n.cropper-point.point-se::before {\n  background-color: #39f;\n  bottom: -50%;\n  content: ' ';\n  display: block;\n  height: 200%;\n  opacity: 0;\n  position: absolute;\n  right: -50%;\n  width: 200%;\n}\n\n.cropper-invisible {\n  opacity: 0;\n}\n\n.cropper-bg {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');\n}\n\n.cropper-hide {\n  display: block;\n  height: 0;\n  position: absolute;\n  width: 0;\n}\n\n.cropper-hidden {\n  display: none !important;\n}\n\n.cropper-move {\n  cursor: move;\n}\n\n.cropper-crop {\n  cursor: crosshair;\n}\n\n.cropper-disabled .cropper-drag-box,\n.cropper-disabled .cropper-face,\n.cropper-disabled .cropper-line,\n.cropper-disabled .cropper-point {\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"index.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".invisible-all{z-index:1;cursor:pointer;position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;width:100%}.outerDiv{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative}input[type=file]::-webkit-file-upload-button{display:none}.photo-actions>div>i{color:#fff!important}.photo-actions>div{float:left;width:50%;position:absolute;text-align:center;bottom:0;cursor:pointer;height:30px}.photo-actions .remove{right:0}.photo-actions{position:absolute;bottom:0;top:0;width:100%;color:#fff!important;background-size:cover;background-image:url(\"https://www.ettravel.com/wp-content/uploads/2016/06/GRADIENT-OVERLAY.png\")}.crop-preview{width:200px;height:200px;overflow:hidden;text-align:center}.crop-preview img{max-width:none;max-height:none;min-width:0;min-height:0;display:block}#imgToCrop{max-width:200px;max-height:200px}.item-image-box img{width:200px;height:200px}.crop-action{cursor:pointer;width:200px;text-align:center}.cropped-box,.item-image-box{width:200px;height:200px;position:relative}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/itens/imageUpload.vue"],"names":[],"mappings":"AACA,eACE,UAAW,AACX,eAAgB,AAChB,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,UAAW,AACX,UAAY,CACb,AACD,UACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,iBAAmB,CACpB,AACD,6CACE,YAAc,CACf,AACD,qBACE,oBAAoB,CACrB,AACD,mBACE,WAAY,AACZ,UAAW,AACX,kBAAmB,AACnB,kBAAmB,AACnB,SAAU,AACV,eAAgB,AAChB,WAAY,CACb,AACD,uBACE,OAAS,CACV,AACD,eACE,kBAAmB,AACnB,SAAU,AACV,MAAO,AACP,WAAY,AACZ,qBAAqB,AACrB,sBAAuB,AACvB,gGAAkG,CACnG,AACD,cACE,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,iBAAmB,CACpB,AACD,kBACE,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,aAAc,AACd,aAAe,CAChB,AACD,WACE,gBAAiB,AACjB,gBAAkB,CACnB,AACD,oBACE,YAAa,AACb,YAAc,CACf,AACD,aACE,eAAgB,AAChB,YAAa,AACb,iBAAmB,CACpB,AACD,6BACE,YAAa,AACb,aAAc,AACd,iBAAmB,CACpB","file":"imageUpload.vue","sourcesContent":["\n.invisible-all{\r\n  z-index: 1;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  opacity: 0;\r\n  width: 100%;\n}\n.outerDiv{\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  position: relative;\n}\ninput[type=file]::-webkit-file-upload-button {\r\n  display: none;\n}\n.photo-actions > div > i{\r\n  color:#fff!important\n}\n.photo-actions > div{\r\n  float: left;\r\n  width: 50%;\r\n  position: absolute;\r\n  text-align: center;\r\n  bottom: 0;\r\n  cursor: pointer;\r\n  height:30px;\n}\n.photo-actions .remove{\r\n  right: 0;\n}\n.photo-actions{\r\n  position: absolute;\r\n  bottom: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  color:#fff!important;\r\n  background-size: cover;\r\n  background-image: url('https://www.ettravel.com/wp-content/uploads/2016/06/GRADIENT-OVERLAY.png');\n}\n.crop-preview{\r\n  width: 200px;\r\n  height: 200px;\r\n  overflow: hidden;\r\n  text-align: center;\n}\n.crop-preview img{\r\n  max-width: none;\r\n  max-height: none;\r\n  min-width: 0;\r\n  min-height: 0;\r\n  display: block;\n}\n#imgToCrop{\r\n  max-width: 200px;\r\n  max-height: 200px;\n}\n.item-image-box img{\r\n  width: 200px;\r\n  height: 200px;\n}\n.crop-action{\r\n  cursor: pointer;\r\n  width: 200px;\r\n  text-align: center;\n}\n.cropped-box, .item-image-box{\r\n  width: 200px;\r\n  height: 200px;\r\n  position: relative;\n}\r\n\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".prefix.input-group--prefix:not(.input-group--focused):not(.input-group--dirty) label{left:23px!important}.item-box{border:1px solid #bdbdbd;border-radius:15px;float:left}.item-imagem{width:60px;float:left}.item-detalhes{float:left;width:calc(100% - 60px);width:-moz-calc(100% - 60px)}.item-imagem img{height:50px;width:50px;border-radius:100%;margin-right:10px}.item-detalhes .item-titulo{font-size:20px;margin-bottom:0}.item-cabecalho,.item-preco,.item-rodape{float:left;width:100%}.price-value-align-right{text-align:right!important}.price-table-error{border:1.5px solid red}.logo{position:relative}.invisible-all{z-index:1;cursor:pointer;position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;width:100%}.outerDiv{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative}input[type=file]::-webkit-file-upload-button{display:none}.photo-actions>div>i{color:#fff!important}.photo-actions>div{float:left;width:50%;position:absolute;text-align:center;bottom:0;cursor:pointer;height:30px}.photo-actions .remove{right:0}.photo-actions{position:absolute;bottom:0;top:0;width:100%;color:#fff!important;background-size:cover;background-image:url(\"https://www.ettravel.com/wp-content/uploads/2016/06/GRADIENT-OVERLAY.png\")}.titulo-detalhes{color:#e62039;font-size:21px}.titulo-detalhes .headline{font-size:25px}.titulo-detalhes-categoria{font-size:21px;padding-top:17px;color:#707983}p{color:#838789}.crop-preview{width:200px;height:200px;overflow:hidden;text-align:center}.crop-preview img{max-width:none;max-height:none;min-width:0;min-height:0;display:block}#imgToCrop{max-width:200px;max-height:200px}.item-image-box img{width:200px;height:200px}.crop-action{cursor:pointer;width:200px;text-align:center}.cropped-box,.item-image-box{width:200px;height:200px;position:relative}.variation-img-box{position:relative}.variation-img-box .box-change-img{display:none;position:absolute;top:0;left:0;height:80%;width:80%;background-size:cover;background-image:url(\"https://www.ettravel.com/wp-content/uploads/2016/06/GRADIENT-OVERLAY.png\")}.variation-img-box .box-change-img button{position:absolute;bottom:4px;left:0;width:100%;color:#fff;outline:none}.variation-img-box:hover .box-change-img{display:block}.variation-img{max-width:80%}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/itens/itemDetalhes.vue"],"names":[],"mappings":"AACA,sFACE,mBAAqB,CACtB,AACD,UACE,yBAA0B,AAC1B,mBAAoB,AACpB,UAAY,CACb,AACD,aACE,WAAY,AACZ,UAAY,CACb,AACD,eACE,WAAY,AACZ,wBAAyB,AACzB,4BAA8B,CAC/B,AACD,iBACE,YAAa,AACb,WAAY,AACZ,mBAAoB,AACpB,iBAAmB,CACpB,AACD,4BACE,eAAgB,AAChB,eAAmB,CACpB,AACD,yCACE,WAAY,AACZ,UAAY,CACb,AACD,yBACE,0BAA4B,CAC7B,AACD,mBACE,sBAAwB,CACzB,AACD,MACE,iBAAmB,CACpB,AACD,eACE,UAAW,AACX,eAAgB,AAChB,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,UAAW,AACX,UAAY,CACb,AACD,UACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,iBAAmB,CACpB,AACD,6CACE,YAAc,CACf,AACD,qBACE,oBAAoB,CACrB,AACD,mBACE,WAAY,AACZ,UAAW,AACX,kBAAmB,AACnB,kBAAmB,AACnB,SAAU,AACV,eAAgB,AAChB,WAAY,CACb,AACD,uBACE,OAAS,CACV,AACD,eACE,kBAAmB,AACnB,SAAU,AACV,MAAO,AACP,WAAY,AACZ,qBAAqB,AACrB,sBAAuB,AACvB,gGAAkG,CACnG,AAED,iBACI,cAAe,AACf,cAAgB,CACnB,AACD,2BACE,cAAgB,CACjB,AACD,2BACE,eAAgB,AAChB,iBAAkB,AAClB,aAAc,CACf,AACD,EACE,aAAc,CACf,AACD,cACE,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,iBAAmB,CACpB,AACD,kBACE,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,aAAc,AACd,aAAe,CAChB,AACD,WACE,gBAAiB,AACjB,gBAAkB,CACnB,AACD,oBACE,YAAa,AACb,YAAc,CACf,AACD,aACE,eAAgB,AAChB,YAAa,AACb,iBAAmB,CACpB,AACD,6BACE,YAAa,AACb,aAAc,AACd,iBAAmB,CACpB,AACD,mBACE,iBAAkB,CACnB,AACD,mCACE,aAAa,AACb,kBAAmB,AACnB,MAAM,AACN,OAAQ,AACR,WAAW,AACX,UAAW,AACX,sBAAuB,AACvB,gGAAkG,CACnG,AACD,0CACE,kBAAkB,AAClB,WAAW,AACX,OAAO,AACP,WAAY,AACZ,WAAW,AACX,YAAc,CACf,AACD,yCAAyC,aAAe,CACvD,AACD,eACE,aAAe,CAChB","file":"itemDetalhes.vue","sourcesContent":["\n.prefix.input-group--prefix:not(.input-group--focused):not(.input-group--dirty) label{\r\n  left: 23px!important;\n}\n.item-box{\r\n  border: 1px solid #bdbdbd;\r\n  border-radius: 15px;\r\n  float: left;\n}\n.item-imagem{\r\n  width: 60px;\r\n  float: left;\n}\n.item-detalhes{\r\n  float: left;\r\n  width: calc(100% - 60px);\r\n  width: -moz-calc(100% - 60px);\n}\n.item-imagem img{\r\n  height: 50px;\r\n  width: 50px;\r\n  border-radius: 100%;\r\n  margin-right: 10px;\n}\n.item-detalhes .item-titulo{\r\n  font-size: 20px;\r\n  margin-bottom: 0px;\n}\n.item-preco, .item-rodape, .item-cabecalho{\r\n  float: left;\r\n  width: 100%;\n}\n.price-value-align-right {\r\n  text-align: right!important;\n}\n.price-table-error {\r\n  border: 1.5px solid red;\n}\n.logo{\r\n  position: relative;\n}\n.invisible-all{\r\n  z-index: 1;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  opacity: 0;\r\n  width: 100%;\n}\n.outerDiv{\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  position: relative;\n}\ninput[type=file]::-webkit-file-upload-button {\r\n  display: none;\n}\n.photo-actions > div > i{\r\n  color:#fff!important\n}\n.photo-actions > div{\r\n  float: left;\r\n  width: 50%;\r\n  position: absolute;\r\n  text-align: center;\r\n  bottom: 0;\r\n  cursor: pointer;\r\n  height:30px;\n}\n.photo-actions .remove{\r\n  right: 0;\n}\n.photo-actions{\r\n  position: absolute;\r\n  bottom: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  color:#fff!important;\r\n  background-size: cover;\r\n  background-image: url('https://www.ettravel.com/wp-content/uploads/2016/06/GRADIENT-OVERLAY.png');\n}\r\n/* ajustes */\n.titulo-detalhes{\r\n    color: #e62039;\r\n    font-size: 21px;\n}\n.titulo-detalhes .headline{\r\n  font-size: 25px;\n}\n.titulo-detalhes-categoria{\r\n  font-size: 21px;\r\n  padding-top: 17px;\r\n  color: #707983\n}\np{\r\n  color: #838789\n}\n.crop-preview{\r\n  width: 200px;\r\n  height: 200px;\r\n  overflow: hidden;\r\n  text-align: center;\n}\n.crop-preview img{\r\n  max-width: none;\r\n  max-height: none;\r\n  min-width: 0;\r\n  min-height: 0;\r\n  display: block;\n}\n#imgToCrop{\r\n  max-width: 200px;\r\n  max-height: 200px;\n}\n.item-image-box img{\r\n  width: 200px;\r\n  height: 200px;\n}\n.crop-action{\r\n  cursor: pointer;\r\n  width: 200px;\r\n  text-align: center;\n}\n.cropped-box, .item-image-box{\r\n  width: 200px;\r\n  height: 200px;\r\n  position: relative;\n}\n.variation-img-box{\r\n  position:relative;\n}\n.variation-img-box .box-change-img{\r\n  display:none;\r\n  position: absolute;\r\n  top:0;\r\n  left: 0;\r\n  height:80%;\r\n  width: 80%;\r\n  background-size: cover;\r\n  background-image: url('https://www.ettravel.com/wp-content/uploads/2016/06/GRADIENT-OVERLAY.png');\n}\n.variation-img-box .box-change-img button{\r\n  position:absolute;\r\n  bottom:4px;\r\n  left:0;\r\n  width: 100%;\r\n  color:#fff;\r\n  outline: none;\n}\n.variation-img-box:hover .box-change-img{display: block;\n}\n.variation-img{\r\n  max-width: 80%;\n}\r\n\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".outerDiv{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.foto,.outerDiv{position:relative}.foto i{display:block}.invisible-all{z-index:1;cursor:pointer;position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;width:100%;max-width:100%}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/itens/Galeria.vue"],"names":[],"mappings":"AACA,UACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAE7B,AACD,gBAFE,iBAAmB,CAIpB,AACD,QACE,aAAe,CAChB,AACD,eACE,UAAW,AACX,eAAgB,AAChB,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,UAAW,AACX,WAAY,AACZ,cAAgB,CACjB","file":"Galeria.vue","sourcesContent":["\n.outerDiv{\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  position: relative;\n}\n.foto{\r\n  position: relative;\n}\n.foto i{\r\n  display: block;\n}\n.invisible-all{\r\n  z-index: 1;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  opacity: 0;\r\n  width: 100%;\r\n  max-width: 100%;\n}\r\n\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".no-transform{text-transform:inherit!important}.box-variacao i{cursor:pointer}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/itens/relacao.vue"],"names":[],"mappings":"AACA,cACE,gCAAkC,CACnC,AACD,gBACE,cAAe,CAChB","file":"relacao.vue","sourcesContent":["\n.no-transform{\n  text-transform: inherit!important;\n}\n.box-variacao i{\n  cursor: pointer\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".item-title{font-weight:600;font-size:20px;margin-bottom:5px}.item-price{color:#129066;font-size:26px}.item-multi-price .item-price{color:#129066;font-size:20px}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/sharedComponents/item/Title.vue"],"names":[],"mappings":"AACA,YACE,gBAAiB,AACjB,eAAgB,AAChB,iBAAmB,CACpB,AACD,YACE,cAAe,AACf,cAAgB,CACjB,AACD,8BACE,cAAe,AACf,cAAgB,CACjB","file":"Title.vue","sourcesContent":["\n.item-title{\n  font-weight: 600;\n  font-size: 20px;\n  margin-bottom: 5px;\n}\n.item-price{\n  color: #129066;\n  font-size: 26px;\n}\n.item-multi-price .item-price{\n  color: #129066;\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".v-meida-holder{text-align:center}img.v-media{height:auto;max-height:150px}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/sharedComponents/item/Media.vue"],"names":[],"mappings":"AACA,gBAAgB,iBAAmB,CAClC,AACD,YAAY,YAAa,gBAAkB,CAC1C","file":"Media.vue","sourcesContent":["\n.v-meida-holder{text-align: center;\n}\nimg.v-media{height: auto;max-height: 150px;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".item-icon i{color:#bdbdbd!important}.green-hover:hover i{color:#66bb6a!important}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/sharedComponents/item/Actions.vue"],"names":[],"mappings":"AACA,aACE,uBAAyB,CAC1B,AACD,qBACE,uBAAyB,CAC1B","file":"Actions.vue","sourcesContent":["\n.item-icon i{\n  color: #bdbdbd!important;\n}\n.green-hover:hover i{\n  color: #66bb6a!important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(603);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("726a4e6c", content, true, {});

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(605);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("1569b42c", content, true, {});

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(607);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("4535f144", content, true, {});

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(615);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("667e80e3", content, true, {});

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(617);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("2d20f175", content, true, {});

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(620);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("63f12674", content, true, {});

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(622);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("10df2819", content, true, {});

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(626);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("3a0c726a", content, true, {});

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(662)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(744),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(652)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(732),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(654)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(734),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(673)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(758),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(669)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(753),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(667)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(751),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(650)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(730),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 730:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('item-media', {
    attrs: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('item-title', {
    attrs: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('item-actions', {
    attrs: {
      "value": _vm.value
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "full-width": "",
      "max-width": "933"
    },
    model: {
      value: (_vm.imageUploadModal),
      callback: function($$v) {
        _vm.imageUploadModal = $$v
      },
      expression: "imageUploadModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', [_c('span', {
    staticClass: "titulo-detalhes pl-4  mt-2 mb-2 headline"
  }, [_vm._v("Subir Imagem")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "logo",
    attrs: {
      "xs12": "",
      "md12": "",
      "pb-3": ""
    }
  }, [(_vm.imgUploadImage) ? _c('div', {
    staticClass: "item-image-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUploadImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "photo-actions"
  }, [_c('div', {
    staticClass: "alter"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v(" Alterar\n                                "), _c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfImage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "remove",
    on: {
      "click": _vm.removeImage
    }
  }, [_c('v-icon', [_vm._v("close")]), _vm._v(" Remover\n                            ")], 1)])]) : [(_vm.shelfedImage !== '') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.cropperOn) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": "",
      "mr-3": ""
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.shelfedImage,
      "alt": "",
      "id": "imgToCrop"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "crop-action",
    on: {
      "click": _vm.crop
    }
  }, [_c('v-icon', [_vm._v("done")]), _vm._v(" Recortar\n                            ")], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "cropped-box"
  }, [_c('div', {
    staticClass: "crop-preview"
  }, [_c('img', {
    style: (_vm.cropPreviewStyle),
    attrs: {
      "src": _vm.shelfedImage,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.cropperOn) ? _c('div', {
    staticClass: "photo-actions"
  }, [_c('div', {
    staticClass: "alter"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v(" Alterar\n                                    "), _c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfImage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "remove",
    on: {
      "click": _vm.unshelfImage
    }
  }, [_c('v-icon', [_vm._v("close")]), _vm._v(" Remover\n                                ")], 1)]) : _vm._e()])])], 1) : [_c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-image-box"
  }, [_c('div', {
    staticClass: "pa-2 noselect foto"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v("\n                                imagem do item\n                            ")], 1)])]]], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 734:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "full-width": "",
      "max-width": "933"
    },
    model: {
      value: (_vm.itemDetalhesModal),
      callback: function($$v) {
        _vm.itemDetalhesModal = $$v
      },
      expression: "itemDetalhesModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', [_c('span', {
    staticClass: "titulo-detalhes pl-4  mt-2 mb-2 headline"
  }, [_vm._v(_vm._s(_vm.item.id === '' ? 'Novo item' : _vm.item.name))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.itemDetalhesModal = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-form', {
    ref: "itemForm",
    attrs: {
      "name": "form-cadastro"
    }
  }, [_c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "pl-5 pr-5",
    staticStyle: {
      "background-color": "#f5f5f5"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes-categoria",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md2": ""
    }
  }, [_vm._v("\n              Categorias\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.categories,
      "rules": _vm.rules.categories,
      "value": _vm.item.categories,
      "item-text": "name",
      "item-value": "id",
      "label": "",
      "single-line": "",
      "bottom": "",
      "required": ""
    },
    on: {
      "input": _vm.updateCategories
    },
    model: {
      value: (_vm.setLocale),
      callback: function($$v) {
        _vm.setLocale = $$v
      },
      expression: "setLocale"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "pb-5": ""
    }
  }, [_vm._v("\n              Detalhes\n            ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "logo",
    attrs: {
      "xs12": "",
      "md12": "",
      "pb-3": ""
    }
  }, [_c('p', [_vm._v("Imagem do Item")]), _vm._v(" "), (_vm.isImg) ? _c('div', {
    staticClass: "item-image-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.images[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "photo-actions"
  }, [_c('div', {
    staticClass: "alter"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v(" Alterar\n                    "), _c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfImage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "remove",
    on: {
      "click": _vm.removeImage
    }
  }, [_c('v-icon', [_vm._v("close")]), _vm._v(" Remover\n                  ")], 1)])]) : [(_vm.shelfedImage !== '') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.cropperOn) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": "",
      "mr-3": ""
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.shelfedImage,
      "alt": "",
      "id": "imgToCrop"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "crop-action",
    on: {
      "click": _vm.crop
    }
  }, [_c('v-icon', [_vm._v("done")]), _vm._v(" Recortar\n                    ")], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "cropped-box"
  }, [_c('div', {
    staticClass: "crop-preview"
  }, [_c('img', {
    style: (_vm.cropPreviewStyle),
    attrs: {
      "src": _vm.shelfedImage,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.cropperOn) ? _c('div', {
    staticClass: "photo-actions"
  }, [_c('div', {
    staticClass: "alter"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v(" Alterar\n                          "), _c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfImage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "remove",
    on: {
      "click": _vm.unshelfImage
    }
  }, [_c('v-icon', [_vm._v("close")]), _vm._v(" Remover\n                        ")], 1)]) : _vm._e()])])], 1) : [_c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-image-box"
  }, [_c('div', {
    staticClass: "pa-2 noselect foto"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v("\n                      imagem do item\n                    ")], 1)])]]], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm11": "",
      "md11": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nome",
      "label": "Nome do item",
      "rules": _vm.rules.name,
      "value": typeof _vm.item.name !== 'undefined' ? _vm.item.name : '',
      "required": ""
    },
    on: {
      "input": _vm.updateName
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Insira o nome do item.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm11": "",
      "md5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "descricao",
      "label": "Descrição",
      "rules": _vm.rules.description,
      "value": typeof _vm.item.description !== 'undefined' ? _vm.item.description : '',
      "multi-line": ""
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "input": _vm.updateDescription
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Descreva detalhadamente o item e suas características.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm11": "",
      "md5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra Chave",
      "append-icon": _vm.dataTags !== '' ? 'send' : '',
      "append-icon-cb": _vm.addTag
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addTag($event)
      }
    },
    model: {
      value: (_vm.dataTags),
      callback: function($$v) {
        _vm.dataTags = $$v
      },
      expression: "dataTags"
    }
  }), _vm._v(" "), _vm._l((_vm.item.tags), function(tag, index) {
    return _c('v-chip', {
      key: index,
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.removeTag(tag)
        }
      }
    }, [_vm._v("\n                " + _vm._s(tag) + "\n              ")])
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Informe palavras que descrevam o item.")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Seu Código",
      "value": _vm.item.code
    },
    on: {
      "input": _vm.updateCode
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Caso seu item possua um código de controle interno, informe aqui.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm11": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Familia",
      "value": _vm.item.family
    },
    on: {
      "input": _vm.updateFamily
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Ex.: limpeza, pet, alimentação, etc.")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "sm12": "",
      "md12": ""
    }
  }, [_vm._v("\n                  Ativo\n                ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('p', [_vm._v("Escolha 'SIM', caso queira que este item apareça no catálogo de produtos/serviços.")]), _vm._v(" "), _c('SelectionBtn', {
    attrs: {
      "value": _vm.item.active
    },
    on: {
      "input": _vm.toggleActive
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sequencia",
      "value": _vm.item.seq
    },
    on: {
      "input": _vm.updateSeq
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Campo sequencia - ordenar os itens por prioridades de visualização, ou seja, os itens que devem ser visualizados primeiro..")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "sm12": "",
      "md12": ""
    }
  }, [_vm._v("\n                  Vigência\n                  "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Determina quando começa e quando termina a exibição do item.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pr-2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Início",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.validityStartLabel),
      callback: function($$v) {
        _vm.validityStartLabel = $$v
      },
      expression: "validityStartLabel"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "value": _vm.validityStartPicker,
      "first-day-of-week": 1,
      "locale": "pt-br",
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    on: {
      "input": _vm.updateValidityStart
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pl-2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Fim",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.validityEndLabel),
      callback: function($$v) {
        _vm.validityEndLabel = $$v
      },
      expression: "validityEndLabel"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "value": _vm.validityEndPicker,
      "first-day-of-week": 1,
      "locale": "pt-br",
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    on: {
      "input": _vm.updateValidityEnd
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_vm._v("\n              Variações\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('p', [_vm._v("Escolha 'SIM', caso este produto/serviço tenha variações no preço.\n                "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Ex: Pequeno, Médio, Grande...")])], 1)], 1), _vm._v(" "), _c('SelectionBtn', {
    attrs: {
      "value": _vm.variacao
    },
    on: {
      "input": _vm.togglePriceVariations
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_vm._v("\n              Preço\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "mb-3": ""
    }
  }, [(_vm.item.priceVariations) ? [_c('v-flex', {
    ref: "pricetableList",
    staticClass: "box-variacao mt-2",
    attrs: {
      "md12": ""
    }
  }, [_vm._l((_vm.item.priceTable), function(variation, index) {
    return [_c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm1": "",
        "md1": "",
        "variation-img-box": ""
      }
    }, [_c('img', {
      staticClass: "variation-img",
      attrs: {
        "src": variation.image,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "box-change-img"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.uploadImage(index, variation.image)
        }
      }
    }, [_vm._v("alterar")])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": "",
        "md3": "",
        "pr-2": ""
      }
    }, [_c('div', {
      staticClass: "price-box"
    }, [_c('v-text-field', {
      attrs: {
        "value": variation.description,
        "label": "Descricão",
        "required": "",
        "rules": _vm.rules.multiDescription
      },
      on: {
        "input": function($event) {
          return _vm.updatePriceText($event, index)
        }
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "sm3": "",
        "md3": ""
      }
    }, [_c('div', {
      staticClass: "price-box"
    }, [_c('money', {
      attrs: {
        "label": 'Valor Referência'
      },
      model: {
        value: (variation.priceRef),
        callback: function($$v) {
          _vm.$set(variation, "priceRef", $$v)
        },
        expression: "variation.priceRef"
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": "",
        "sm1": "",
        "md1": "",
        "pt-2": ""
      }
    }, [_c('v-tooltip', {
      attrs: {
        "right": ""
      }
    }, [_c('v-icon', {
      staticClass: "ml-2 link",
      attrs: {
        "slot": "activator",
        "color": "blue"
      },
      slot: "activator"
    }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Valor original sem desconto.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "sm3": "",
        "md3": ""
      }
    }, [_c('div', {
      staticClass: "price-box"
    }, [_c('money', {
      attrs: {
        "validation": true
      },
      model: {
        value: (variation.price),
        callback: function($$v) {
          _vm.$set(variation, "price", $$v)
        },
        expression: "variation.price"
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": "",
        "sm1": "",
        "md1": "",
        "pt-2": ""
      }
    }, [_c('v-tooltip', {
      attrs: {
        "right": ""
      }
    }, [_c('v-icon', {
      staticClass: "ml-2 link",
      attrs: {
        "slot": "activator",
        "color": "blue"
      },
      slot: "activator"
    }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Valor com desconto.")])], 1), _vm._v(" "), _c('v-icon', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteMultiPrice(index)
        }
      }
    }, [_vm._v("delete")])], 1)], 1)]
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {}, [_c('v-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addMultiPrice($event)
      }
    }
  }, [_vm._v("add")])], 1)], 2)] : [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "mt-3": ""
    }
  }, [_c('div', {
    staticClass: "price-box"
  }, [_c('money', {
    attrs: {
      "validation": true
    },
    model: {
      value: (_vm.item.price),
      callback: function($$v) {
        _vm.$set(_vm.item, "price", $$v)
      },
      expression: "item.price"
    }
  })], 1)])]], 2)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_vm._v("\n              Formas de pagamento\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.payments,
      "value": _vm.item.payments,
      "multiple": "",
      "item-text": "description",
      "item-value": "id",
      "label": "",
      "single-line": "",
      "bottom": "",
      "required": ""
    },
    on: {
      "input": _vm.updatePayments
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "titulo-detalhes",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_vm._v("\n              O tipo de serviço que sua empresa presta requer definição de horários?\n              "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Coloque sim, caso o tipo de serviço prestado pela sua empresa tenha horários de atendimentos diferenciados durante a semana.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('SelectionBtn', {
    staticClass: "font-14",
    attrs: {
      "value": _vm.needSchedule
    },
    on: {
      "input": _vm.toggleNeedSchedule
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": ""
    }
  }, [(_vm.needSchedule) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Sábado")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.saturdayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateSaturdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.saturdayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateSaturdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.saturdayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateSaturdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.saturdayCapacity
    },
    on: {
      "change": _vm.updateSaturdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Domingo")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.sundayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateSundayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.sundayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateSundayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.sundayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateSundayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.sundayCapacity
    },
    on: {
      "change": _vm.updateSundayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.customTime) ? [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Segunda a Sexta")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.weekDayStart,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateWeekdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.weekDayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateWeekdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.weekDayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateWeekdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.weekDayCapacity
    },
    on: {
      "change": _vm.updateWeekdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)] : [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Segunda")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.mondayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateMondayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.mondayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateMondayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.mondayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateMondayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.mondayCapacity
    },
    on: {
      "change": _vm.updateMondayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)]], 2) : _vm._e(), _vm._v(" "), (_vm.needSchedule && _vm.customTime) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Terça")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.tuesdayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateTuesdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.tuesdayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateTuesdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.tuesdayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateTuesdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.tuesdayCapacity
    },
    on: {
      "change": _vm.updateTuesdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule && _vm.customTime) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Quarta")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.wednesdayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateWednesdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.wednesdayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateWednesdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.wednesdayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateWednesdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.wednesdayCapacity
    },
    on: {
      "change": _vm.updateWednesdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule && _vm.customTime) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Quinta")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.thursdayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateThursdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.thursdayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateThursdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.thursdayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateThursdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.thursdayCapacity
    },
    on: {
      "change": _vm.updateThursdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule && _vm.customTime) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Sexta")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.item.fridayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateFridayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.item.fridayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateFridayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.item.fridayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateFridayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.item.fridayCapacity
    },
    on: {
      "change": _vm.updateFridayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md6": ""
    }
  }, [_c('p', {}, [_vm._v("Horários distintos durante a semana")]), _vm._v(" "), _c('SelectionBtn', {
    attrs: {
      "value": _vm.customTime
    },
    on: {
      "input": _vm.toggleCustomTime
    }
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Se o tipo de serviço prestado pela sua empresa tem horários de atendimentos diferenciados durante a semana, preencha a próxima tela.")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "mt-3": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-4",
    attrs: {
      "flat": "",
      "outline": "",
      "round": "",
      "color": "green",
      "disabled": _vm.loadingItemAction
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateItem()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("done_all")]), _vm._v("Gravar")], 1)], 1)], 1), _vm._v(" "), (_vm.loadingItemAction) ? _c('v-progress-linear', {
    staticClass: "loading-modal",
    attrs: {
      "color": "error",
      "indeterminate": true
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', [_c('ImageUpload')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 744:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_vm._l((4), function(n, i) {
    return [_c('v-flex', {
      key: i,
      class: _vm.fotos[n - 1] !== undefined ? 'text-xs-center pa-2 outerDiv' : 'text-xs-center pa-2 outerDiv',
      attrs: {
        "md3": ""
      }
    }, [(_vm.fotos[n - 1] !== undefined) ? _c('div', {
      staticClass: "outerDiv"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": _vm.fotos[n - 1],
        "alt": ""
      }
    })]) : [_c('input', {
      staticClass: "invisible-all",
      attrs: {
        "type": "file",
        "name": "",
        "value": ""
      },
      on: {
        "change": _vm.adicionarFoto
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "outerDiv"
    }, [_c('div', {
      staticClass: "pa-2 noselect foto"
    }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v("\n              adicionar foto\n            ")], 1)])]], 2)]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 748:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md5": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-green no-transform",
    attrs: {
      "round": "",
      "large": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.itemEscolha('')
      }
    }
  }, [_c('span', {
    staticClass: "pr-1"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add_circle_outline")])], 1), _vm._v("\n      Novo item\n    ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-blue no-transform",
    attrs: {
      "round": "",
      "large": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filterActive(2)
      }
    }
  }, [_vm._v("\n      Todos\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-green no-transform",
    attrs: {
      "round": "",
      "large": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filterActive(1)
      }
    }
  }, [_vm._v("\n      Ativos\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-red no-transform",
    attrs: {
      "round": "",
      "large": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filterActive(0)
      }
    }
  }, [_vm._v("\n      Inativos\n    ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "searchInput",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "label": "Pesquisar itens",
      "append-icon": "search"
    },
    model: {
      value: (_vm.searchItem),
      callback: function($$v) {
        _vm.searchItem = $$v
      },
      expression: "searchItem"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md10": ""
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.filteredItens), function(item) {
    return _c('v-flex', {
      key: item.id,
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('ItemCard', {
      attrs: {
        "value": item
      }
    })], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-flex', [_c('ItemDetalhes')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 751:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-title', [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.value.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.value.description))]), _c('br'), _vm._v(" "), (!_vm.value.priceVariations) ? [_c('span', {
    staticClass: "item-price"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.value.price)))])] : [_c('span', {
    staticClass: "item-price"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.value.priceTable[0].price)))]), (_vm.value.priceTable.length > 1) ? _c('span', [_vm._v(" e mais " + _vm._s(_vm.value.priceTable.length - 1) + "...")]) : _vm._e()]], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 753:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-meida-holder"
  }, [_c('img', {
    staticClass: "v-media",
    attrs: {
      "src": _vm.image
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (true) ? _c('v-card-actions', [_c('v-flex', [_c('selection-btn', {
    attrs: {
      "value": _vm.value.active
    },
    on: {
      "input": function($event) {
        return _vm.activateItem(_vm.value)
      }
    }
  }, [_vm._v("Ativo")])], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "value": _vm.value.seq,
      "label": "Sequencia",
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('span', [_vm._v("Editar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "flat": "",
      "color": "grey lighten-1"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.itemEscolha(_vm.value.id)
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("create")])], 1)], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('span', [_vm._v("Excluir")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "icon": "",
      "color": "grey lighten-1"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogExclude($event)
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('span', [_vm._v("Divulgar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "flat": "",
      "color": "grey lighten-1"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.newSchedule(_vm.value.id)
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("domain")])], 1)], 1), _vm._v(" "), (_vm.exclude) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.exclude),
      callback: function($$v) {
        _vm.exclude = $$v
      },
      expression: "exclude"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Excluir item")]), _vm._v(" "), _c('v-card-text', [_vm._v("Deseja realmente excluir este item?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green lighten-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.exclude = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green lighten-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.excludeItem($event)
      }
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.01519d08456dc796da48.js